import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, NgModule, ElementRef, Component, ChangeDetectionStrategy, ViewChild, Input, EventEmitter, forwardRef, TemplateRef, ContentChild, Output, HostListener, HostBinding, Directive, Inject, QueryList, ContentChildren, Pipe, Self, Optional } from '@angular/core';
import * as i2$1 from '@angular/material/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import dayjs from 'dayjs';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i5 from '@angular/material/autocomplete';
import { MatAutocompleteTrigger, MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i3$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2$2 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import * as i1$1 from '@headpower/blah-ng';
import { BlahModule } from '@headpower/blah-ng';
import * as i4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3$1 from '@angular/material/form-field';
import * as i9 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i3$3 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject, BehaviorSubject, timer, ReplaySubject } from 'rxjs';
import * as i5$1 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { takeUntil, debounceTime, take } from 'rxjs/operators';
import * as i2$3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i6 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i7 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import * as i1$2 from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import * as i5$2 from '@angular/cdk/portal';
import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import * as i4$1 from '@angular/material/menu';
import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import * as i4$2 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';

/**************************************************
*                                                 *
* Internal Day.js typings for components library. *
*                                                 *
* Types should match with exported dayjs loader.  *
*                                                 *
**************************************************/

/** InjectionToken for dayjs date adapter to configure options. */
const _c0 = ["defaultButton"];
const _c1 = ["raisedButton"];
const _c2 = ["*", "*", "*", "*", "*"];
const _c3 = (a0, a1) => ({
  "no-min-width": a0,
  "no-pointers": a1
});
const _c4 = a0 => ({
  "no-pointers": a0
});
const _c5 = (a0, a1) => [a0, a1];
function ButtonComponent_button_0_ng_container_2_ng_content_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngTemplateOutlet", "content"]);
  }
}
function ButtonComponent_button_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ButtonComponent_button_0_ng_container_2_ng_content_1_Template, 1, 0, "ng-content", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const content_r1 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
  }
}
function ButtonComponent_button_0_ng_container_3_ng_content_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["*ngTemplateOutlet", "loader"]);
  }
}
function ButtonComponent_button_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ButtonComponent_button_0_ng_container_3_ng_content_1_Template, 1, 0, "ng-content", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const loader_r2 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", loader_r2);
  }
}
function ButtonComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 6, 2);
    i0.ɵɵtemplate(2, ButtonComponent_button_0_ng_container_2_Template, 2, 1, "ng-container", 7)(3, ButtonComponent_button_0_ng_container_3_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r2.loading ? ctx_r2.buttonWidth + "px" : null);
    i0.ɵɵproperty("id", ctx_r2.internalId)("color", ctx_r2.color)("disabled", ctx_r2.disabled)("ngClass", i0.ɵɵpureFunction2(9, _c3, ctx_r2.icon, ctx_r2.loading || ctx_r2.readonly || ctx_r2.disabled));
    i0.ɵɵattribute("tabindex", ctx_r2.tabbable && !ctx_r2.loading && !ctx_r2.readonly ? null : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loading);
  }
}
function ButtonComponent_button_1_ng_container_2_ng_content_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2, ["*ngTemplateOutlet", "content"]);
  }
}
function ButtonComponent_button_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ButtonComponent_button_1_ng_container_2_ng_content_1_Template, 1, 0, "ng-content", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const content_r1 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r1);
  }
}
function ButtonComponent_button_1_ng_container_3_ng_content_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 3, ["*ngTemplateOutlet", "loader"]);
  }
}
function ButtonComponent_button_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ButtonComponent_button_1_ng_container_3_ng_content_1_Template, 1, 0, "ng-content", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const loader_r2 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", loader_r2);
  }
}
function ButtonComponent_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 9, 3);
    i0.ɵɵtemplate(2, ButtonComponent_button_1_ng_container_2_Template, 2, 1, "ng-container", 7)(3, ButtonComponent_button_1_ng_container_3_Template, 2, 1, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r2.loading ? ctx_r2.buttonWidth + "px" : null);
    i0.ɵɵproperty("id", ctx_r2.internalId)("color", ctx_r2.color)("disabled", ctx_r2.disabled)("ngClass", i0.ɵɵpureFunction1(9, _c4, ctx_r2.loading || ctx_r2.readonly || ctx_r2.disabled));
    i0.ɵɵattribute("tabindex", ctx_r2.tabbable && !ctx_r2.loading && !ctx_r2.readonly ? null : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.loading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.loading);
  }
}
function ButtonComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 4);
  }
}
function ButtonComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div");
    i0.ɵɵelement(2, "mat-spinner", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c5, ctx_r2.internalType === 0 ? "default" : "raised", ctx_r2.internalColor))("diameter", 24)("strokeWidth", 3);
  }
}
const _c6 = a0 => [a0];
const _c7 = a0 => ({
  $implicit: a0
});
function SelectContainerComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.translateTitle ? i0.ɵɵpipeBind1(2, 1, ctx_r1.title) : ctx_r1.title);
  }
}
function SelectContainerComponent_ng_container_10_mat_list_option_2_2_ng_template_0_Template(rf, ctx) {}
function SelectContainerComponent_ng_container_10_mat_list_option_2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SelectContainerComponent_ng_container_10_mat_list_option_2_2_ng_template_0_Template, 0, 0, "ng-template", 11, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const item_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction1(3, _c6, item_r4))("ngTemplateOutlet", ctx_r1.templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c7, item_r4));
  }
}
function SelectContainerComponent_ng_container_10_mat_list_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-list-option", 9)(1, "div", 10);
    i0.ɵɵtemplate(2, SelectContainerComponent_ng_container_10_mat_list_option_2_2_Template, 2, 7, null, 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", item_r4._tooltip);
    i0.ɵɵproperty("id", "multi-select-mat-list-option-" + item_r4._index)("value", item_r4._index)("selected", item_r4._checked);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.id, "-select-option-", item_r4._index, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._data.length > 0);
  }
}
function SelectContainerComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-selection-list", 7);
    i0.ɵɵlistener("selectionChange", function SelectContainerComponent_ng_container_10_Template_mat_selection_list_selectionChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectionChangeHandler($event));
    });
    i0.ɵɵtemplate(2, SelectContainerComponent_ng_container_10_mat_list_option_2_Template, 3, 8, "mat-list-option", 8);
    i0.ɵɵelement(3, "mat-option");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1._data);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("display", "none");
  }
}
function SelectContainerComponent_ng_container_11_mat_option_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 14);
    i0.ɵɵpipe(1, "blah");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.id, "-select-option-empty");
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 5, "components.clearSelection"));
    i0.ɵɵproperty("value", -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 7, "components.clearSelection"), " ");
  }
}
function SelectContainerComponent_ng_container_11_mat_option_2_2_ng_template_0_Template(rf, ctx) {}
function SelectContainerComponent_ng_container_11_mat_option_2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SelectContainerComponent_ng_container_11_mat_option_2_2_ng_template_0_Template, 0, 0, "ng-template", 11, 2, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction1(3, _c6, item_r5))("ngTemplateOutlet", ctx_r1.templateRef)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c7, item_r5));
  }
}
function SelectContainerComponent_ng_container_11_mat_option_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 15)(1, "div", 10);
    i0.ɵɵtemplate(2, SelectContainerComponent_ng_container_11_mat_option_2_2_Template, 2, 7, null, 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", item_r5._tooltip);
    i0.ɵɵproperty("value", item_r5._index);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate2("id", "", ctx_r1.id, "-select-option-", item_r5._index, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._data.length > 0);
  }
}
function SelectContainerComponent_ng_container_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SelectContainerComponent_ng_container_11_mat_option_1_Template, 4, 9, "mat-option", 12)(2, SelectContainerComponent_ng_container_11_mat_option_2_Template, 3, 6, "mat-option", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.allowEmpty && ctx_r1.value && ctx_r1.value !== "-1");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._data);
  }
}
const _c8 = ["*"];
function CardHeaderComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 4)(2, "mat-icon");
    i0.ɵɵtext(3, " expand_more ");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r0.expandDisabled);
    i0.ɵɵattribute("id", ctx_r0.id ? ctx_r0.id + "-expand-button" : null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@expandCollapseIcon", ctx_r0.expandIconState);
  }
}
const _c9 = [[["hpo-card-header"]], [["", 5, "hpo-card-header"]]];
const _c10 = ["hpo-card-header", ":not(hpo-card-header)"];
const _c11 = (a0, a1) => ({
  "desktop": a0,
  "mobile": a1
});
const _c12 = a0 => ({
  "hpo-datepicker-errors": a0
});
function DatetimepickerComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.datePlaceholder);
  }
}
function DatetimepickerComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.errorMessage);
  }
}
function DatetimepickerComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 9);
    i0.ɵɵlistener("click", function DatetimepickerComponent_Conditional_8_Template_mat_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      i0.ɵɵnextContext();
      const picker_r4 = i0.ɵɵreference(7);
      return i0.ɵɵresetView(picker_r4.open());
    });
    i0.ɵɵtext(1, "today");
    i0.ɵɵelementEnd();
  }
}
function DatetimepickerComponent_Conditional_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.timePlaceholder);
  }
}
function DatetimepickerComponent_Conditional_9_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-icon", 9);
    i0.ɵɵlistener("click", function DatetimepickerComponent_Conditional_9_Conditional_4_Template_mat_icon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      ctx_r1.setCurrentTime();
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵtext(1, "access_time");
    i0.ɵɵelementEnd();
  }
}
function DatetimepickerComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "mat-form-field", 10);
    i0.ɵɵtemplate(2, DatetimepickerComponent_Conditional_9_Conditional_2_Template, 2, 1, "mat-label");
    i0.ɵɵelementStart(3, "input", 11);
    i0.ɵɵlistener("change", function DatetimepickerComponent_Conditional_9_Template_input_change_3_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTimeInputValueChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DatetimepickerComponent_Conditional_9_Conditional_4_Template, 2, 0, "mat-icon", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c12, ctx_r1.showErrorHint));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.timePlaceholder ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", ctx_r1.id, "-time");
    i0.ɵɵproperty("disabled", ctx_r1.disabled || ctx_r1.dateValue == null)("value", ctx_r1.TimeInputValue)("maxLength", 10);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.disabled ? 4 : -1);
  }
}
const _c13 = a0 => ({
  "read-only": a0
});
function InputComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.placeholder);
  }
}
function InputComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", (ctx_r0.value == null ? null : ctx_r0.value.length) || "0", " / ", ctx_r0.maxlength, "");
  }
}
function BottomSheetComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("click", function BottomSheetComponent_div_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("@overlayState", undefined);
  }
}
function BottomSheetComponent_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
  }
}
function BottomSheetComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("@sheetState.done", function BottomSheetComponent_div_1_Template_div_animation_sheetState_done_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.sheetStateChanged($event));
    });
    i0.ɵɵtemplate(1, BottomSheetComponent_div_1_div_1_Template, 2, 1, "div", 4);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@sheetState", undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.label);
  }
}
const _c14 = a0 => ({
  "nav-item-active": a0
});
const _c15 = ["map"];
function TextareaComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.placeholder);
  }
}
function TextareaComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", (ctx_r0.value == null ? null : ctx_r0.value.length) || "0", " / ", ctx_r0.maxlength, "");
  }
}
function NotificationComponent_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function NotificationComponent_div_0_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeClick());
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "clear");
    i0.ɵɵelementEnd()();
  }
}
function NotificationComponent_div_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "hpo-button", 8);
    i0.ɵɵlistener("click", function NotificationComponent_div_0_div_6_Template_hpo_button_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.linkClick());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.linkText, " ");
  }
}
function NotificationComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("@fadeInOut.done", function NotificationComponent_div_0_Template_div_animation_fadeInOut_done_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.animationDone($event));
    });
    i0.ɵɵelementStart(1, "div", 2)(2, "div");
    i0.ɵɵtemplate(3, NotificationComponent_div_0_div_3_Template, 3, 0, "div", 3);
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵprojection(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, NotificationComponent_div_0_div_6_Template, 3, 1, "div", 5);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeInOut", undefined);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r1.width);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("message-container ", ctx_r1.color, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.closeable);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("font-size", ctx_r1.fontSize);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.displayLink);
  }
}
const _c16 = (a0, a1) => ({
  "right": a0,
  "left": a1
});
function HpoNumberComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.placeholder);
  }
}
function HpoNumberComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("align", ctx_r0.textAlign !== "left" ? "end" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "components.nan"));
  }
}
function HpoNumberComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 2);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "blah");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("align", ctx_r0.textAlign !== "left" ? "end" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 2, "components.notPositiveNumber"));
  }
}
function TextComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.placeholder);
  }
}
function TextComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", (ctx_r0.value == null ? null : ctx_r0.value.length) || "0", " / ", ctx_r0.maxlength, "");
  }
}
const _c17 = ".mat-mdc-input-element[_ngcontent-%COMP%]:read-only{cursor:default}.mat-mdc-form-field.read-only[_ngcontent-%COMP%]     .mdc-line-ripple{display:none}";
function NoteComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.placeholder);
  }
}
function NoteComponent_mat_hint_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", (ctx_r0.value == null ? null : ctx_r0.value.length) || "0", " / ", ctx_r0.maxlength, " ");
  }
}
const _c18 = a0 => ({
  "width": a0
});
const _c19 = a0 => ({
  height: a0
});
function PlaceholderComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div", 3)(2, "div", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c19, (ctx_r0.rows * 20).toString() + "px"));
  }
}
function PlaceholderComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelement(2, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function PlaceholderComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵelement(2, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
const _c20 = ["block"];
const _c21 = ["grid"];
const _c22 = ["toolbar"];
const _c23 = (a0, a1) => ({
  "mat-sidenav": true,
  "mat-sidenav-desktop": a0,
  "mat-sidenav-handheld": a1
});
const _c24 = a0 => ({
  "grid-template-rows": a0
});
const _c25 = (a0, a1, a2, a3, a4) => ({
  "condensed": a0,
  "fullscreen": a1,
  "mobile": a2,
  "navigation": a3,
  "no-navigation": a4
});
const _c26 = a0 => ({
  "shadow": a0
});
const _c27 = a0 => ({
  "width.px": a0
});
const _c28 = a0 => ({
  "top": a0
});
const _c29 = a0 => ({
  "selected": a0
});
function ContentLayoutComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ContentLayoutComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ContentLayoutComponent_div_13_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ContentLayoutComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13, 1);
    i0.ɵɵtemplate(2, ContentLayoutComponent_div_13_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c26, ctx_r1.toolbarShadow))("ngStyle", i0.ɵɵpureFunction1(5, _c27, ctx_r1.gridWidth));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.toolbarTemplate);
  }
}
function ContentLayoutComponent_div_16_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ContentLayoutComponent_div_16_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, ContentLayoutComponent_div_16_div_2_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.aboveNavigationTemplate);
  }
}
function ContentLayoutComponent_div_16_li_4_mat_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const props_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("matTooltip", props_r5.iconTooltip);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(props_r5.icon);
  }
}
function ContentLayoutComponent_div_16_li_4_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const props_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(props_r5.icon);
  }
}
function ContentLayoutComponent_div_16_li_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 20);
    i0.ɵɵlistener("click", function ContentLayoutComponent_div_16_li_4_Template_li_click_0_listener() {
      const ctx_r3 = i0.ɵɵrestoreView(_r3);
      const props_r5 = ctx_r3.$implicit;
      const i_r6 = ctx_r3.index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.moveToSection(i_r6, props_r5.anchor));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, ContentLayoutComponent_div_16_li_4_mat_icon_2_Template, 2, 2, "mat-icon", 21)(3, ContentLayoutComponent_div_16_li_4_mat_icon_3_Template, 2, 1, "mat-icon", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const props_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "", props_r5.id, "-navigation-button");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c29, i_r6 === ctx_r1.highlightIndex));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", props_r5.title, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", props_r5.icon && props_r5.iconTooltip);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", props_r5.icon && !props_r5.iconTooltip);
  }
}
function ContentLayoutComponent_div_16_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ContentLayoutComponent_div_16_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, ContentLayoutComponent_div_16_div_5_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.belowNavigationTemplate);
  }
}
function ContentLayoutComponent_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtemplate(2, ContentLayoutComponent_div_16_div_2_Template, 2, 1, "div", 16);
    i0.ɵɵelementStart(3, "ul", 17);
    i0.ɵɵtemplate(4, ContentLayoutComponent_div_16_li_4_Template, 4, 8, "li", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, ContentLayoutComponent_div_16_div_5_Template, 2, 1, "div", 16);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c11, !ctx_r1.mobile, ctx_r1.mobile));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c28, ctx_r1.toolbarTemplate ? "calc(" + ctx_r1.toolbarHeight + "px" + " + 6.5rem)" : "6.5rem"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.aboveNavigationTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.blockProperties);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.belowNavigationTemplate);
  }
}
function FullScreenDialogComponent_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "hpo-button", 12);
    i0.ɵɵlistener("click", function FullScreenDialogComponent_Conditional_13_Template_hpo_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.actionClicked());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "blah");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tabbable", false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.rawLabels ? ctx_r2.actionLabel : i0.ɵɵpipeBind1(3, 2, ctx_r2.actionLabel), " ");
  }
}
function FullScreenDialogComponent_ng_template_16_Template(rf, ctx) {}
const _c30 = (a0, a1) => ({
  "out-of-context": a0,
  "in-context": a1
});
const _c31 = ["actionButtons"];
const _c32 = (a0, a1) => ({
  button: a0,
  showBtn: a1
});
const _c33 = (a0, a1, a2) => ({
  "fab-screen-layer": a0,
  "fab-screen-layer-mobile": a1,
  "fab-screen-layer-hidden": a2
});
const _c34 = (a0, a1, a2, a3, a4, a5) => ({
  "visible": a0,
  "hidden": a1,
  "desktop": a2,
  "mobile": a3,
  "closed": a4,
  "open": a5
});
const _c35 = (a0, a1) => ({
  "width.px": a0,
  "height.px": a1
});
const _c36 = (a0, a1) => ({
  "visible": a0,
  "hidden": a1
});
const _c37 = a0 => ({
  "visible": a0
});
const _c38 = () => ({
  "width.px": 56,
  "height.px": 56
});
function FloatingActionButtonComponent_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 11);
    i0.ɵɵlistener("click", function FloatingActionButtonComponent_div_0_div_2_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView((ctx_r2.buttons == null ? null : ctx_r2.buttons.length) > 1 ? ctx_r2.fabOpenState(true) : ctx_r2.actionClicked(ctx_r2.buttons[0].id));
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3, "add");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c37, !ctx_r2.buttonsAreVisible));
  }
}
function FloatingActionButtonComponent_div_0_hpo_floating_action_button_item_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "hpo-floating-action-button-item", 12);
    i0.ɵɵlistener("click", function FloatingActionButtonComponent_div_0_hpo_floating_action_button_item_6_Template_hpo_floating_action_button_item_click_0_listener() {
      const button_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.actionClicked(button_r5.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r5 = ctx.$implicit;
    i0.ɵɵproperty("title", button_r5.title)("id", button_r5.id)("icon", button_r5.icon)("outOfContext", button_r5.outOfContext)("colorOptions", button_r5.colorOptions);
  }
}
function FloatingActionButtonComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 6);
    i0.ɵɵtemplate(2, FloatingActionButtonComponent_div_0_div_2_Template, 4, 3, "div", 7);
    i0.ɵɵelementStart(3, "div", 8, 1)(5, "div", 9);
    i0.ɵɵtemplate(6, FloatingActionButtonComponent_div_0_hpo_floating_action_button_item_6_Template, 1, 5, "hpo-floating-action-button-item", 10);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction6(6, _c34, ctx_r2.isVisible, !ctx_r2.isVisible, !ctx_r2.mobile, ctx_r2.mobile, !ctx_r2.buttonsAreVisible, ctx_r2.buttonsAreVisible))("ngStyle", i0.ɵɵpureFunction2(13, _c35, !ctx_r2.buttonsAreVisible ? 56 : ctx_r2.width, !ctx_r2.buttonsAreVisible ? 56 : ctx_r2.height));
    i0.ɵɵattribute("id", ctx_r2.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.buttonsAreVisible);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(16, _c36, ctx_r2.buttonsAreVisible, !ctx_r2.buttonsAreVisible));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.buttons);
  }
}
function FloatingActionButtonComponent_ng_template_3_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 11);
    i0.ɵɵlistener("click", function FloatingActionButtonComponent_ng_template_3_div_0_div_2_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const button_r7 = i0.ɵɵnextContext(2).button;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.actionClicked(button_r7.id));
    });
    i0.ɵɵelementStart(2, "mat-icon");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    const button_r7 = ctx_r7.button;
    const showBtn_r9 = ctx_r7.showBtn;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c37, showBtn_r9));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(button_r7.icon);
  }
}
function FloatingActionButtonComponent_ng_template_3_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 6);
    i0.ɵɵtemplate(2, FloatingActionButtonComponent_ng_template_3_div_0_div_2_Template, 4, 4, "div", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const showBtn_r9 = i0.ɵɵnextContext().showBtn;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction6(4, _c34, ctx_r2.isVisible, !ctx_r2.isVisible || !showBtn_r9, !ctx_r2.mobile, ctx_r2.mobile, showBtn_r9, !showBtn_r9))("ngStyle", i0.ɵɵpureFunction0(11, _c38));
    i0.ɵɵattribute("id", ctx_r2.id + "-secondary-action");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", showBtn_r9);
  }
}
function FloatingActionButtonComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, FloatingActionButtonComponent_ng_template_3_div_0_Template, 3, 12, "div", 13);
  }
  if (rf & 2) {
    const button_r7 = ctx.button;
    i0.ɵɵproperty("ngIf", button_r7);
  }
}
function HpoButtonItemComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
const _c39 = ["primaryButton"];
const _c40 = ["primaryDropdownButton"];
function HpoSplitButtonComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HpoSplitButtonComponent_For_11_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HpoSplitButtonComponent_For_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function HpoSplitButtonComponent_For_11_Template_button_click_0_listener($event) {
      const ɵ$index_16_r3 = i0.ɵɵrestoreView(_r2).$index;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.secondaryButtonClick(ɵ$index_16_r3, $event));
    });
    i0.ɵɵtemplate(1, HpoSplitButtonComponent_For_11_ng_container_1_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const buttonItem_r5 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", buttonItem_r5.color && "mat-" + buttonItem_r5.color || ctx_r3.color && "mat-" + ctx_r3.color)("disabled", buttonItem_r5.disabled);
    i0.ɵɵattribute("id", buttonItem_r5.id);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", buttonItem_r5.templateRef);
  }
}
const _c41 = ["input"];
function MultiSearchFilterComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-checkbox", 4);
    i0.ɵɵpipe(2, "lowercase");
    i0.ɵɵlistener("change", function MultiSearchFilterComponent_ng_container_1_Template_mat_checkbox_change_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onToggleChange($event.checked));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(2, 4, "checkbox-filter-" + ctx_r1.id))("checked", ctx_r1.value)("disabled", ctx_r1.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
  }
}
function MultiSearchFilterComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field")(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "input", 5, 0);
    i0.ɵɵpipe(6, "lowercase");
    i0.ɵɵlistener("input", function MultiSearchFilterComponent_ng_container_2_Template_input_input_4_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onTextChange($event.target.value));
    })("focus", function MultiSearchFilterComponent_ng_container_2_Template_input_focus_4_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocus());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(6, 4, "text-input-filter-" + ctx_r1.id))("value", ctx_r1.value)("disabled", ctx_r1.disabled);
  }
}
function MultiSearchFilterComponent_ng_container_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", item_r5.searchValues, " ");
  }
}
function MultiSearchFilterComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "hpo-select", 6);
    i0.ɵɵpipe(2, "lowercase");
    i0.ɵɵlistener("selectedChange", function MultiSearchFilterComponent_ng_container_3_Template_hpo_select_selectedChange_1_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onSelectChange($event));
    });
    i0.ɵɵtemplate(3, MultiSearchFilterComponent_ng_container_3_ng_template_3_Template, 1, 1, "ng-template");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", ctx_r1.title);
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(2, 12, "dropdown-list-filter-" + ctx_r1.id))("data", ctx_r1.options)("multiple", ctx_r1.multiple)("showTooltip", ctx_r1.showTooltip)("selected", ctx_r1.selectedOption)("allowEmpty", true)("searchBy", "searchValues")("disabled", ctx_r1.disabled)("isRequired", ctx_r1.isRequired)("errorStateMatcher", ctx_r1.errorStateMatcher)("errorMessage", ctx_r1.errorMessage);
  }
}
function MultiSearchFilterComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "hpo-datetimepicker", 8);
    i0.ɵɵpipe(3, "lowercase");
    i0.ɵɵtwoWayListener("valueChange", function MultiSearchFilterComponent_ng_container_4_Template_hpo_datetimepicker_valueChange_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedStartDate, $event) || (ctx_r1.selectedStartDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function MultiSearchFilterComponent_ng_container_4_Template_hpo_datetimepicker_valueChange_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDateChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "hpo-datetimepicker", 9);
    i0.ɵɵpipe(5, "lowercase");
    i0.ɵɵtwoWayListener("valueChange", function MultiSearchFilterComponent_ng_container_4_Template_hpo_datetimepicker_valueChange_4_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedEndDate, $event) || (ctx_r1.selectedEndDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("valueChange", function MultiSearchFilterComponent_ng_container_4_Template_hpo_datetimepicker_valueChange_4_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDateChange());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(3, 11, "start-date-input-filter-" + ctx_r1.id));
    i0.ɵɵtwoWayProperty("value", ctx_r1.selectedStartDate);
    i0.ɵɵproperty("hideTimeInput", true)("datePlaceholder", ctx_r1.title)("disabled", ctx_r1.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(5, 13, "end-date-input-filter-" + ctx_r1.id));
    i0.ɵɵtwoWayProperty("value", ctx_r1.selectedEndDate);
    i0.ɵɵproperty("hideTimeInput", true)("endOfDayTime", true)("datePlaceholder", ctx_r1.subTitle)("disabled", ctx_r1.disabled);
  }
}
function MultiSearchFilterComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "mat-form-field")(3, "mat-label");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "input", 10, 0);
    i0.ɵɵpipe(7, "lowercase");
    i0.ɵɵlistener("change", function MultiSearchFilterComponent_ng_container_5_Template_input_change_5_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onExactNumberChange($event.target.value));
    })("focus", function MultiSearchFilterComponent_ng_container_5_Template_input_focus_5_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocus());
    });
    i0.ɵɵtwoWayListener("valueChange", function MultiSearchFilterComponent_ng_container_5_Template_input_valueChange_5_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value, $event) || (ctx_r1.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(7, 4, "number-input-filter-" + ctx_r1.id));
    i0.ɵɵtwoWayProperty("value", ctx_r1.value);
    i0.ɵɵproperty("disabled", ctx_r1.disabled);
  }
}
function MultiSearchFilterComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7)(2, "hpo-number", 11);
    i0.ɵɵpipe(3, "lowercase");
    i0.ɵɵtwoWayListener("numberChange", function MultiSearchFilterComponent_ng_container_6_Template_hpo_number_numberChange_2_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedValueMin, $event) || (ctx_r1.selectedValueMin = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("numberChange", function MultiSearchFilterComponent_ng_container_6_Template_hpo_number_numberChange_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNumberChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "hpo-number", 11);
    i0.ɵɵpipe(5, "lowercase");
    i0.ɵɵtwoWayListener("numberChange", function MultiSearchFilterComponent_ng_container_6_Template_hpo_number_numberChange_4_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedValueMax, $event) || (ctx_r1.selectedValueMax = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("numberChange", function MultiSearchFilterComponent_ng_container_6_Template_hpo_number_numberChange_4_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onNumberChange());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(3, 10, "number-input-min-filter-" + ctx_r1.id))("placeholder", ctx_r1.title);
    i0.ɵɵtwoWayProperty("number", ctx_r1.selectedValueMin);
    i0.ɵɵproperty("emitNullAsZero", true)("readonly", ctx_r1.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", i0.ɵɵpipeBind1(5, 12, "number-input-max-filter-" + ctx_r1.id))("placeholder", ctx_r1.subTitle);
    i0.ɵɵtwoWayProperty("number", ctx_r1.selectedValueMax);
    i0.ɵɵproperty("emitNullAsZero", true)("readonly", ctx_r1.disabled);
  }
}
function MultiSearchFilterComponent_ng_container_7_mat_chip_row_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip-row", 14);
    i0.ɵɵlistener("removed", function MultiSearchFilterComponent_ng_container_7_mat_chip_row_6_Template_mat_chip_row_removed_0_listener() {
      const avalue_r11 = i0.ɵɵrestoreView(_r10).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.removeChipValue(avalue_r11));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 15);
    i0.ɵɵtext(3, "cancel");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const avalue_r11 = ctx.$implicit;
    i0.ɵɵproperty("selectable", true)("removable", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", avalue_r11, " ");
  }
}
function MultiSearchFilterComponent_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-form-field")(2, "mat-label");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-chip-grid", null, 1);
    i0.ɵɵtemplate(6, MultiSearchFilterComponent_ng_container_7_mat_chip_row_6_Template, 4, 3, "mat-chip-row", 12);
    i0.ɵɵelementStart(7, "input", 13);
    i0.ɵɵpipe(8, "blah");
    i0.ɵɵlistener("matChipInputTokenEnd", function MultiSearchFilterComponent_ng_container_7_Template_input_matChipInputTokenEnd_7_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.addChipValue($event));
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const chipList_r12 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.title);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(8, 5, "components.addNew"));
    i0.ɵɵproperty("matChipInputFor", chipList_r12)("matChipInputAddOnBlur", true);
  }
}
const MAT_DAYJS_DATE_ADAPTER_OPTIONS = new InjectionToken('MAT_DAYJS_DATE_ADAPTER_OPTIONS', {
  providedIn: 'root',
  factory: MAT_DAYJS_DATE_ADAPTER_OPTIONS_FACTORY
});
/** @docs-private */
function MAT_DAYJS_DATE_ADAPTER_OPTIONS_FACTORY() {
  return {
    useUtc: false
  };
}
function range(length, valueFunction) {
  const valuesArray = Array(length);
  for (let i = 0; i < length; i++) {
    valuesArray[i] = valueFunction(i);
  }
  return valuesArray;
}
let DayjsDateAdapter = /*#__PURE__*/(() => {
  class DayjsDateAdapter extends DateAdapter {
    constructor() {
      super();
      this._options = inject(MAT_DAYJS_DATE_ADAPTER_OPTIONS, {
        optional: true
      });
      const dateLocale = inject(MAT_DATE_LOCALE, {
        optional: true
      });
      this.setLocale(dateLocale || dayjs.locale());
    }
    setLocale(locale) {
      const parsedLocale = this.parseBlahLocale(locale);
      super.setLocale(parsedLocale);
      const localeData = dayjs().locale(parsedLocale).localeData();
      this._localeData = {
        firstDayOfWeek: localeData.firstDayOfWeek(),
        longMonths: localeData.months(),
        shortMonths: localeData.monthsShort(),
        dates: range(31, i => this.createDate(2017, 0, i + 1).format('D')),
        longDaysOfWeek: localeData.weekdays(),
        shortDaysOfWeek: localeData.weekdaysShort(),
        narrowDaysOfWeek: localeData.weekdaysMin()
      };
    }
    getYear(date) {
      return this.clone(date).year();
    }
    getMonth(date) {
      return this.clone(date).month();
    }
    getDate(date) {
      return this.clone(date).date();
    }
    getDayOfWeek(date) {
      return this.clone(date).day();
    }
    getMonthNames(style) {
      // Day.js doesn't support narrow month names, so we just use short if narrow is requested.
      return style === 'long' ? this._localeData.longMonths : this._localeData.shortMonths;
    }
    getDateNames() {
      return this._localeData.dates;
    }
    getDayOfWeekNames(style) {
      if (style === 'long') {
        return this._localeData.longDaysOfWeek;
      }
      if (style === 'short') {
        return this._localeData.shortDaysOfWeek;
      }
      return this._localeData.narrowDaysOfWeek;
    }
    getYearName(date) {
      return this.clone(date).format('YYYY');
    }
    getFirstDayOfWeek() {
      return this._localeData.firstDayOfWeek;
    }
    getNumDaysInMonth(date) {
      return this.clone(date).daysInMonth();
    }
    clone(date) {
      return date.clone().locale(this.locale);
    }
    createDate(year, month, date) {
      return this._createDayjs({
        year,
        month,
        date
      }).locale(this.locale);
    }
    today() {
      return this._createDayjs().locale(this.locale);
    }
    parse(value, parseFormat) {
      if (value && typeof value === 'string') {
        return this._createDayjs(value, parseFormat, this.locale);
      }
      return value ? this._createDayjs(value).locale(this.locale) : null;
    }
    format(date, displayFormat) {
      return this.clone(date).format(displayFormat);
    }
    addCalendarYears(date, years) {
      return this.clone(date).add(years, 'year');
    }
    addCalendarMonths(date, months) {
      return this.clone(date).add(months, 'month');
    }
    addCalendarDays(date, days) {
      return this.clone(date).add(days, 'day');
    }
    toIso8601(date) {
      return this.clone(date).format();
    }
    deserialize(value) {
      let date;
      if (value instanceof Date) {
        date = this._createDayjs(value).locale(this.locale);
      } else if (this.isDateInstance(value)) {
        // Note: assumes that cloning also sets the correct locale.
        return this.clone(value);
      }
      if (typeof value === 'string') {
        if (!value) {
          return null;
        }
        date = this._createDayjs(value).locale(this.locale);
      }
      if (date && this.isValid(date)) {
        return this._createDayjs(date).locale(this.locale);
      }
      return super.deserialize(value);
    }
    isDateInstance(obj) {
      return dayjs.isDayjs(obj);
    }
    isValid(date) {
      return this.clone(date).isValid();
    }
    invalid() {
      // Produces invalid dayjs
      return dayjs(NaN);
    }
    // Creates a dayjs instance while respecting the current UTC settings
    _createDayjs(date, format, locale) {
      const {
        strict,
        useUtc
      } = this._options || {};
      return useUtc ? dayjs.utc(date, format, strict) : dayjs(date, format, locale, strict);
    }
    // Blah locale is in format fi-FI, sv-SE, en-US and dayjs has fi, sv, en
    parseBlahLocale(locale) {
      return locale.split('-')[0];
    }
    static {
      this.ɵfac = function DayjsDateAdapter_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DayjsDateAdapter)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DayjsDateAdapter,
        factory: DayjsDateAdapter.ɵfac
      });
    }
  }
  return DayjsDateAdapter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MAT_DAYJS_DATE_FORMATS = {
  parse: {
    dateInput: 'l'
  },
  display: {
    dateInput: 'l',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
let DayjsDateModule = /*#__PURE__*/(() => {
  class DayjsDateModule {
    static {
      this.ɵfac = function DayjsDateModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DayjsDateModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DayjsDateModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: DateAdapter,
          useClass: DayjsDateAdapter,
          deps: [MAT_DATE_LOCALE, MAT_DAYJS_DATE_ADAPTER_OPTIONS]
        }]
      });
    }
  }
  return DayjsDateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatDayjsDateModule = /*#__PURE__*/(() => {
  class MatDayjsDateModule {
    static {
      this.ɵfac = function MatDayjsDateModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatDayjsDateModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MatDayjsDateModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDayjsDateAdapter()]
      });
    }
  }
  return MatDayjsDateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideDayjsDateAdapter(formats = MAT_DAYJS_DATE_FORMATS, options) {
  const providers = [{
    provide: DateAdapter,
    useClass: DayjsDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_DAYJS_DATE_ADAPTER_OPTIONS]
  }, {
    provide: MAT_DATE_FORMATS,
    useValue: formats
  }];
  if (options) {
    providers.push({
      provide: MAT_DAYJS_DATE_ADAPTER_OPTIONS,
      useValue: options
    });
  }
  return providers;
}

/**
 * Available colors
 */
var Color = /*#__PURE__*/function (Color) {
  Color["default"] = "";
  Color["primary"] = "primary";
  Color["accent"] = "accent";
  Color["warn"] = "warn";
  return Color;
}(Color || {});
/**
 * Available types
 */
var Type = /*#__PURE__*/function (Type) {
  Type[Type["default"] = 0] = "default";
  Type[Type["raised"] = 1] = "raised";
  return Type;
}(Type || {});
/**
 * HeadPower component for displaying buttons
 */
let ButtonComponent = /*#__PURE__*/(() => {
  class ButtonComponent {
    constructor() {
      this.disabled = false;
      this.tabbable = true;
      this.loading = false;
      this.readonly = false;
      this.icon = false;
      this.internalType = Type.default;
      this.internalColor = Color.default;
      this.internalId = 'help-i-have-no-id';
    }
    ngOnInit() {
      this.internalType = this.getType(this.type);
      this.internalColor = this.getColor(this.color);
      this.internalId = this.getId(this.id);
    }
    ngOnChanges(changes) {
      if (changes['type']) {
        this.internalType = this.getType(changes['type'].currentValue);
      }
      if (changes['color']) {
        this.internalColor = this.getColor(changes['color'].currentValue);
      }
      if (changes['id']) {
        this.internalId = this.getId(changes['id'].currentValue);
      }
      if (changes['loading'] && !changes['loading'].firstChange && changes['loading'].currentValue) {
        const buttonElem = this.internalType === Type.default ? this.defaultButtonElem : this.raisedButtonElem;
        this.buttonWidth = buttonElem.nativeElement.clientWidth;
        // TODO: Animations.
        // It's pretty impossible to do nice animation for the button width changes
        // because we don't know the width in advance.
      }
    }
    /**
     * Get proper type selector
     *
     * @param type button type
     * @returns number
     */
    getType(type) {
      switch (type) {
        case 'raised':
          return Type.raised;
        default:
          return Type.default;
      }
    }
    /**
     * Get right color values
     *
     * @param color color of the button (default, primary, accent, warn)
     * @returns Color type
     */
    getColor(color) {
      color = color?.split('-')[0] ?? '';
      switch (color) {
        case 'primary':
          return Color.primary;
        case 'accent':
          return Color.accent;
        case 'warn':
          return Color.warn;
        default:
          return Color.default;
      }
    }
    /**
     * Get id
     *
     * @param id input id
     * @returns id or default value
     */
    getId(id) {
      if (id) {
        return id + '-sub';
      }
      return 'no-id-given';
    }
    static {
      this.ɵfac = function ButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonComponent,
        selectors: [["hpo-button"]],
        viewQuery: function ButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5, ElementRef);
            i0.ɵɵviewQuery(_c1, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.defaultButtonElem = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.raisedButtonElem = _t.first);
          }
        },
        hostVars: 6,
        hostBindings: function ButtonComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("disabled", ctx.disabled)("loading", ctx.loading)("readonly", ctx.readonly);
          }
        },
        inputs: {
          id: "id",
          type: "type",
          color: "color",
          disabled: "disabled",
          tabbable: "tabbable",
          loading: "loading",
          readonly: "readonly",
          icon: "icon"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c2,
        decls: 6,
        vars: 2,
        consts: [["content", ""], ["loader", ""], ["defaultButton", ""], ["raisedButton", ""], ["mat-button", "", "class", "hpo-button", 3, "id", "color", "disabled", "ngClass", "width", 4, "ngIf"], ["mat-raised-button", "", "class", "hpo-button", 3, "id", "color", "disabled", "ngClass", "width", 4, "ngIf"], ["mat-button", "", 1, "hpo-button", 3, "id", "color", "disabled", "ngClass"], [4, "ngIf"], [4, "ngTemplateOutlet"], ["mat-raised-button", "", 1, "hpo-button", 3, "id", "color", "disabled", "ngClass"], [1, "spinner-container"], [3, "ngClass", "diameter", "strokeWidth"]],
        template: function ButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c2);
            i0.ɵɵtemplate(0, ButtonComponent_button_0_Template, 4, 12, "button", 4)(1, ButtonComponent_button_1_Template, 4, 11, "button", 5)(2, ButtonComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, ButtonComponent_ng_template_4_Template, 3, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.internalType === 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.internalType === 1);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2.MatButton, i3.MatProgressSpinner],
        styles: [".disabled[_nghost-%COMP%], .loading[_nghost-%COMP%], .readonly[_nghost-%COMP%]{pointer-events:none}button[_ngcontent-%COMP%]{padding:0 .8rem;font-weight:500;text-transform:uppercase;transition:all .1s ease-in-out}button[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{transition:all .1s ease}.no-min-width[_ngcontent-%COMP%]{min-width:0}.no-pointers[_ngcontent-%COMP%]{pointer-events:none}.spinner-container[_ngcontent-%COMP%]{display:inline-block}"],
        changeDetection: 0
      });
    }
  }
  return ButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonModule = /*#__PURE__*/(() => {
  class ButtonModule {
    static {
      this.ɵfac = function ButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule]
      });
    }
  }
  return ButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * HeadPower component for indicating loading
 */
let SpinnerComponent = /*#__PURE__*/(() => {
  class SpinnerComponent {
    constructor() {
      this.value = 0;
      this.size = 100;
    }
    ngOnInit() {
      this.position = this.getPosition(this.userPosition);
      this.mode = this.userMode == 'progress' ? 'determinate' : 'indeterminate';
      this.color = this.getColor(this.userColor);
    }
    getPosition(position) {
      const availablePositions = ['left', 'center', 'right'];
      return availablePositions.indexOf(position) > -1 ? position : availablePositions[0];
    }
    getColor(color) {
      const availableColors = ['primary', 'accent', 'warn'];
      return availableColors.indexOf(color) > -1 ? color : availableColors[0];
    }
    static {
      this.ɵfac = function SpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SpinnerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SpinnerComponent,
        selectors: [["hpo-spinner"]],
        inputs: {
          userPosition: [0, "position", "userPosition"],
          userColor: [0, "color", "userColor"],
          userMode: [0, "mode", "userMode"],
          value: "value",
          size: "size"
        },
        decls: 2,
        vars: 5,
        consts: [[3, "ngClass"], [3, "mode", "color", "value", "diameter"]],
        template: function SpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "mat-progress-spinner", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.position);
            i0.ɵɵadvance();
            i0.ɵɵproperty("mode", ctx.mode)("color", ctx.color)("value", ctx.value)("diameter", ctx.size);
          }
        },
        dependencies: [i1.NgClass, i3.MatProgressSpinner],
        styles: [".center[_ngcontent-%COMP%] > mat-progress-spinner[_ngcontent-%COMP%]{margin:0 auto}.right[_ngcontent-%COMP%]:after{content:\"\";display:table;clear:both}.right[_ngcontent-%COMP%] > mat-progress-spinner[_ngcontent-%COMP%]{float:right}"],
        changeDetection: 0
      });
    }
  }
  return SpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SpinnerModule = /*#__PURE__*/(() => {
  class SpinnerModule {
    static {
      this.ɵfac = function SpinnerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SpinnerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SpinnerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatProgressSpinnerModule]
      });
    }
  }
  return SpinnerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * HeadPower component for item selection with Blah localization support
 */
let SelectContainerComponent = /*#__PURE__*/(() => {
  class SelectContainerComponent {
    set value(val) {
      if (val !== undefined && this.val !== val) {
        this.val = val;
        this.onChange(val);
        this.onTouch(val);
      }
    }
    get value() {
      return this.val;
    }
    constructor(cdRef, blahService) {
      this.cdRef = cdRef;
      this.blahService = blahService;
      this.initiallySelected = null; // index of the selected item
      this.searchValue = ''; // the search value of the input
      this.displayText = '';
      this.tooltipText = '';
      this.selectedOptions = [];
      this._data = [];
      this.val = '';
      this.id = '';
      /*
       * Show dropdown option in tooltip
       */
      this.showTooltip = false;
      this.title = '';
      /*
       * Component takes in objects that have the property 'Name'
       */
      this.data = [];
      /*
       * Optional parameter for defining initially selected option, e.g. a value that was
       * selected earlier or a default option
      */
      this.selected = {};
      /*
       * Name of the property to use for searching
       */
      this.searchBy = '';
      /*
       * Property for telling the component if it should use Blah to translate title
       */
      this.translateTitle = false;
      /*
       * Property for telling the component if it should allow empty values to be given and to be selected
       */
      this.allowEmpty = false;
      /**
       * Tell the component if selection should be disabled
       */
      this.disabled = false;
      /**
       * Allow select one or multiple options in dropdown (default one)
       */
      this.multiple = false;
      /**
       * Set required attribute to select input
       */
      this.isRequired = false;
      /*
       * Component emits single selected objects from the given data array
       */
      this.selectedChange = new EventEmitter(true);
      this.onChange = () => {};
      this.onTouch = () => {};
      /**
       * Returns the right value to the search field when an object is selected from options
       */
      this.valueMapper = key => {
        if (key === -1 || key === null) {
          return;
        }
        let selected = this._data.find(e => e._index === key);
        if (selected) {
          if (!this.multiple || this.multiple && this.initiallySelected === null) {
            this.searchValue = selected[this.searchBy];
            return selected[this.searchBy];
          }
        }
        return this.selected[this.searchBy];
      };
    }
    ngOnInit() {
      this.applyIndex(this.data);
      this.updateCheckedItems(this.data);
      this.sortItems(this.data);
      this._data = this.data;
    }
    ngOnDestroy() {}
    ngAfterViewInit() {
      if (this.multiple) {
        this._subscribeToClosingActions();
        this.setDisplayValue();
      }
    }
    /**
     * Ran when component inputs change
     * @param changes changes
     */
    ngOnChanges(changes) {
      // Index dataset to make it easier to return right objects when selected
      if (changes.data) {
        this.applyIndex(this.data);
        this._data = this.data;
      }
      if (changes.selected) {
        // reset selected values
        this.selectedOptions = [];
        if (this.multiple && Array.isArray(this.selected)) {
          // add object index to selected options
          this.selected.forEach(o => {
            const prop = o.hasOwnProperty("Name") ? "Name" : "name";
            this.selectedOptions.push(this.data.find(i => i[this.searchBy] === o[this.searchBy] && i[prop] === o[prop])._index);
          });
          this.updateCheckedItems(this.data);
          // get index of the initially selected object
          let index = this.selected.findIndex(o => this.data.some(i => i[this.searchBy] === o[this.searchBy] && i._index === this.initiallySelected));
          // if index found set initially value as selected object
          this.selected = index >= 0 ? this.selected[index] : this.selected[0];
        }
        this.setInitialValue();
        if (!this.multiple) {
          // update basic dropdown list
          this._data = this.data;
        }
      }
      this.cdRef.markForCheck();
    }
    /**
     * Set initial value of the dropdown list
     */
    setInitialValue() {
      if (!this.isNullOrUndefined(this.selected)) {
        this.searchValue = this.selected[this.searchBy];
        // Set initial value
        this.initiallySelected = this.data.find(item => {
          const prop = item.hasOwnProperty("Name") ? "Name" : "name";
          return item[this.searchBy] === this.searchValue && item[prop] === this.selected[prop];
        })._index;
        this.value = this.selected;
        // Need to update input's text, because it isn't changed unless selected index changes
        this.displayText = this.valueMapper(this.initiallySelected);
        // add initial value to selected options
        if (this.multiple && !this.selectedOptions.includes(this.initiallySelected)) {
          this.selectedOptions.push(this.initiallySelected);
          this.updateCheckedItems(this.data);
          this.sortItems(this.data);
          this._data = this.data;
        }
      } else {
        this.searchValue = '';
        this.initiallySelected = null;
        this.value = null;
        // Update if selected options are manually reset and the panel is closed
        if (this.multiple && this.trigger && !this.trigger.panelOpen) {
          this.updateCheckedItems(this.data);
          this.sortItems(this.data);
          this._data = this.data;
        }
      }
    }
    /**
     * Set custom display text for input
     * Used for multi-select
     */
    setDisplayValue() {
      let newValue = this.searchValue == null ? '' : String(this.searchValue);
      let selected_text = '';
      if (newValue.length > 0) {
        selected_text = this.selectedOptions.length > 1 ? ' (+' + (this.selectedOptions.length - 1) + ')' : '';
      }
      this.displayText = newValue + selected_text;
    }
    /**
     * Add index property to given data
     * @param arr Array of items
     * @returns Given data with indexed items
     */
    applyIndex(arr) {
      if (!arr || arr.length === 0) {
        return [];
      }
      if (this.multiple) {
        arr.forEach((item, index) => {
          item['_index'] = index;
          item['_checked'] = false;
          return item;
        });
      } else {
        arr.forEach((item, index) => {
          item['_index'] = index;
          return item;
        });
      }
      if (this.showTooltip) {
        arr.forEach(item => {
          item['_tooltip'] = item[this.searchBy];
          return item;
        });
      }
      return arr;
    }
    /**
     * Clear input field value
     */
    clearInput() {
      if (!this.multiple) return;
      this.displayText = '';
      this.applyFilter('');
    }
    /**
     * Filter results by name
     * @param filter Filter text
     */
    applyFilter(filter) {
      if (this.isNullOrUndefined(filter)) {
        this._data = this.data;
        return;
      }
      const _filter = filter.toString().toLowerCase();
      if (filter.length === 0) {
        if (!this.multiple) {
          // reset when clear value on basic dropdown list
          this.emit(null);
        }
        this._data = this.data;
        return;
      }
      if (filter === '') {
        this._data = this.data;
        return;
      }
      this._data = this.data.filter(item => {
        return item[this.searchBy].toLowerCase().includes(_filter);
      });
    }
    /**
     * Updates from input text
     * @param event input string
     */
    update(value) {
      this.searchValue = value;
      this.applyFilter(value);
      this.cdRef.markForCheck();
    }
    /**
     * Handle update when selected value has been changed
     * @param e event
     */
    selectionChangeHandler(e) {
      const index = e.options[0]?.value;
      if (this.selectedOptions.includes(index)) {
        this.selectedOptions = this.selectedOptions.filter(o => o !== index);
      } else {
        this.selectedOptions.push(index);
      }
      let temp = JSON.parse(JSON.stringify(this.data));
      let items = temp.filter(e => this.selectedOptions.includes(e._index));
      let value = items.length === 0 ? null : items;
      this.emit(value);
    }
    /**
     * Map checked property to object
     * @param arr
     * @returns
     */
    updateCheckedItems(arr) {
      if (arr.length == 0) return arr;
      arr.forEach(item => item._checked = this.selectedOptions.includes(item._index));
      return arr;
    }
    /**
     * Sort array of objects based on selected values
     */
    sortItems(arr) {
      if (arr.length == 0) return arr;
      arr.sort((a, b) => {
        if (a._checked < b._checked) {
          return 1;
        }
        if (a._checked > b._checked) {
          return -1;
        }
        if (a._index > b._index) {
          return 1;
        }
        if (a._index < b._index) {
          return -1;
        }
        return 0;
      });
      return arr;
    }
    /**
     * Listen autocomplete close action
     */
    _subscribeToClosingActions() {
      if (this.subscription && !this.subscription.closed) {
        this.subscription.unsubscribe();
      }
      this.subscription = this.trigger.panelClosingActions.subscribe({
        next: e => {
          if (!e || !e.source) {
            // Run update only if selected options are reset while the panel is open
            if (this.selectedOptions.length === 0) {
              this.updateCheckedItems(this.data);
            }
            // Reorder items when dropdown menu is closed
            this.sortItems(this.data);
            this._data = this.data;
            this.cdRef.detectChanges();
            this.setDisplayValue();
          }
        },
        error: () => this._subscribeToClosingActions(),
        complete: () => this._subscribeToClosingActions()
      });
    }
    /**
     * Emit values back to the parent component
     * @param value Selected value
     */
    emit(value) {
      if (this.isNullOrUndefined(value)) {
        this.selectedChange.emit(null);
        return;
      }
      // remove private properties before emitting value
      let temp = JSON.parse(JSON.stringify(value));
      if (this.multiple) {
        temp.forEach(element => {
          delete element['_index'];
          delete element['_checked'];
          delete element['_tooltip'];
        });
      } else {
        delete temp['_index'];
        delete temp['_checked'];
        delete temp['_tooltip'];
      }
      this.selectedChange.emit(temp);
      this.cdRef.markForCheck();
    }
    /**
     * Emit values back to the parent component
     * Method used to emit only basic dropdown events (not multi-select)
     * @param value Selected value
     */
    emitSelected(value) {
      const key = value.option.value;
      if (key === -1) {
        this.emit(null);
        return;
      }
      let selected = this.data.find(e => e._index === key);
      if (selected) {
        this.emit(selected);
      }
    }
    /**
     * Used to check if property value is null or undefined
     * @param property property value
     */
    isNullOrUndefined(prop) {
      if (prop === undefined || prop === null) {
        return true;
      }
      return false;
    }
    /**
     * Set value programmatically
     */
    writeValue(value) {
      this.value = value;
      this.cdRef.markForCheck();
    }
    /**
     * WhenUI element value changes, this method gets triggered
     */
    registerOnChange(fn) {
      this.onChange = fn;
      this.cdRef.markForCheck();
    }
    /**
     * When touching the element, this method gets triggered
     */
    registerOnTouched(fn) {
      this.onTouch = fn;
      this.cdRef.markForCheck();
    }
    static {
      this.ɵfac = function SelectContainerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectContainerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$1.BlahService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SelectContainerComponent,
        selectors: [["hpo-select"]],
        contentQueries: function SelectContainerComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
          }
        },
        viewQuery: function SelectContainerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatAutocompleteTrigger, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
          }
        },
        inputs: {
          id: "id",
          showTooltip: "showTooltip",
          title: "title",
          data: "data",
          selected: "selected",
          searchBy: "searchBy",
          translateTitle: "translateTitle",
          allowEmpty: "allowEmpty",
          disabled: "disabled",
          multiple: "multiple",
          isRequired: "isRequired",
          errorStateMatcher: "errorStateMatcher",
          errorMessage: "errorMessage"
        },
        outputs: {
          selectedChange: "selectedChange"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => SelectContainerComponent),
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 12,
        vars: 14,
        consts: [["input", ""], ["auto", "matAutocomplete"], ["options", ""], ["type", "text", "matInput", "", "ngDefaultControl", "", 3, "input", "click", "id", "title", "value", "ngModel", "matAutocomplete", "errorStateMatcher", "disabled", "required"], ["matSuffix", ""], ["autoActiveFirstOption", "", "panelWidth", "fit-content", 3, "optionSelected", "displayWith"], [4, "ngIf"], [3, "selectionChange"], ["checkboxPosition", "before", 3, "id", "value", "selected", "title", 4, "ngFor", "ngForOf"], ["checkboxPosition", "before", 3, "id", "value", "selected", "title"], [3, "id"], ["ngFor", "", 3, "ngForOf", "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "id", "value", "title", 4, "ngIf"], [3, "value", "title", 4, "ngFor", "ngForOf"], [3, "id", "value", "title"], [3, "value", "title"]],
        template: function SelectContainerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "mat-form-field");
            i0.ɵɵtemplate(1, SelectContainerComponent_Conditional_1_Template, 3, 3, "mat-label");
            i0.ɵɵelementStart(2, "input", 3, 0);
            i0.ɵɵlistener("input", function SelectContainerComponent_Template_input_input_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.update($event.target.value));
            })("click", function SelectContainerComponent_Template_input_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.clearInput());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-icon", 4);
            i0.ɵɵtext(5, "arrow_drop_down");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "mat-error");
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "mat-autocomplete", 5, 1);
            i0.ɵɵlistener("optionSelected", function SelectContainerComponent_Template_mat_autocomplete_optionSelected_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitSelected($event));
            });
            i0.ɵɵtemplate(10, SelectContainerComponent_ng_container_10_Template, 4, 3, "ng-container", 6)(11, SelectContainerComponent_ng_container_11_Template, 3, 2, "ng-container", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const input_r6 = i0.ɵɵreference(3);
            const auto_r7 = i0.ɵɵreference(9);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.title ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-select-input");
            i0.ɵɵpropertyInterpolate("title", ctx.showTooltip ? input_r6.value : "");
            i0.ɵɵproperty("value", ctx.displayText)("ngModel", ctx.initiallySelected)("matAutocomplete", auto_r7)("errorStateMatcher", ctx.errorStateMatcher)("disabled", ctx.disabled)("required", ctx.isRequired);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.errorMessage);
            i0.ɵɵadvance();
            i0.ɵɵproperty("displayWith", ctx.valueMapper);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.multiple);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.multiple);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i3$1.MatFormField, i3$1.MatLabel, i3$1.MatError, i3$1.MatSuffix, i2$1.MatOption, i5.MatAutocomplete, i5.MatAutocompleteTrigger, i4.DefaultValueAccessor, i4.NgControlStatus, i4.RequiredValidator, i4.NgModel, i2$2.MatInput, i3$2.MatIcon, i9.MatSelectionList, i9.MatListOption, i1$1.BlahPipe],
        changeDetection: 0
      });
    }
  }
  return SelectContainerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectModule = /*#__PURE__*/(() => {
  class SelectModule {
    static {
      this.ɵfac = function SelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatSelectModule, BlahModule, MatAutocompleteModule, FormsModule, ReactiveFormsModule, MatInputModule, MatIconModule, ButtonModule, MatButtonModule, MatCheckboxModule, MatInputModule, MatListModule]
      });
    }
  }
  return SelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardHeaderComponent = /*#__PURE__*/(() => {
  class CardHeaderComponent {
    get expandIconState() {
      return this.expanded ? 'expanded' : 'collapsed';
    }
    constructor(cdRef) {
      this.cdRef = cdRef;
      this.expandable = false;
      this.expandDisabled = false;
      this.expanded = false;
      this.expandChangeSubject = new Subject();
      this.hasPendingChanges = false;
    }
    ngOnDestroy() {
      this.expandChangeSubject.complete();
    }
    expandCollapseClick() {
      if (!this.hasPendingChanges) {
        this.expanded = !this.expanded;
        this.expandChangeSubject.next(this.expanded);
      }
    }
    updateExpandProperties(prop) {
      this.hasPendingChanges = true;
      // Due to nature of the card component properties logic,
      // header properties must be drawn in a later change detection cycle to prevent expression change after change detection.
      //
      // Also the ContentChild setters in card component wont trigger change detection
      // so a new macrotask is required anyways.
      setTimeout(() => {
        this.expandable = prop.expandable;
        this.expandDisabled = prop.expandDisabled;
        this.expanded = prop.expanded;
        this.hasPendingChanges = false;
        this.cdRef.markForCheck();
      });
    }
    static {
      this.ɵfac = function CardHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardHeaderComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardHeaderComponent,
        selectors: [["hpo-card-header"]],
        inputs: {
          id: "id",
          color: "color"
        },
        ngContentSelectors: _c8,
        decls: 4,
        vars: 5,
        consts: [[1, "header", 3, "click", "ngClass"], [1, "title"], ["class", "expand-icon", 4, "ngIf"], [1, "expand-icon"], ["mat-icon-button", "", 3, "disabled"]],
        template: function CardHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function CardHeaderComponent_Template_div_click_0_listener() {
              return ctx.expandable ? ctx.expandCollapseClick() : null;
            });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, CardHeaderComponent_div_3_Template, 4, 3, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.color);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("expandable", ctx.expandable);
            i0.ɵɵattribute("id", ctx.id ? ctx.id + "-title" : null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.expandable);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.MatIconButton, i3$2.MatIcon],
        styles: [".header[_ngcontent-%COMP%]{font-size:1.6rem;font-weight:500;line-height:1;display:flex;flex-direction:row;align-items:center}.header.primary[_ngcontent-%COMP%]{color:var(--color-primary-darker-contrast);background-color:var(--color-primary-darker)}.header.accent[_ngcontent-%COMP%]{color:var(--color-accent-darker-contrast);background-color:var(--color-accent-darker)}.header.warn[_ngcontent-%COMP%]{color:var(--color-warn-darker-contrast);background-color:var(--color-warn-darker)}.header[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-weight:500;margin:.8rem 1.6rem;padding:.8rem 0;flex-grow:2;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.header[_ngcontent-%COMP%]   .title.expandable[_ngcontent-%COMP%]{margin:.8rem .8rem .8rem 1.6rem;cursor:pointer}.header[_ngcontent-%COMP%]   .expand-icon[_ngcontent-%COMP%]{margin:0 .8rem 0 0}.header[_ngcontent-%COMP%]   .expand-icon[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]:disabled{color:#aaa}"],
        data: {
          animation: [trigger('expandCollapseIcon', [state('collapsed', style({
            transform: 'rotate(0deg)'
          })), state('expanded', style({
            transform: 'rotate(180deg)'
          })), transition('collapsed <=> expanded', animate('300ms cubic-bezier(0.645, 0.045, 0.355, 1)'))])]
        },
        changeDetection: 0
      });
    }
  }
  return CardHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardComponent = /*#__PURE__*/(() => {
  class CardComponent {
    set headerComponentSet(value) {
      if (value !== this.headerComponent) {
        this.headerComponent = value;
        this.updateHeaderExpandProperties();
        this.updateHeaderExpandChangeHook();
      }
    }
    set headerElemRefSet(value) {
      if (value !== this.headerElemRef) {
        this.headerElemRef = value;
        this.checkHeaderElemPlacement();
      }
    }
    get expandState() {
      return this.expanded ? 'expanded' : 'collapsed';
    }
    constructor(hostElemRef, cdRef) {
      this.hostElemRef = hostElemRef;
      this.cdRef = cdRef;
      this.mobile = false;
      this.expandable = false;
      this.expandDisabled = false;
      this.expanded = true;
      this.opened = new EventEmitter();
      this.closed = new EventEmitter();
      this.afterExpand = new EventEmitter();
      this.afterCollapse = new EventEmitter();
    }
    ngOnChanges(changes) {
      if (changes.expandable || changes.expandDisabled || changes.expanded) {
        // When this triggers first time content is not yet projected and all references are undefined.
        // Methods are aware of that.
        // 
        // Also ngOnChanges wont notify if f.ex. this.expanded is changed inside component.
        // It only takes external Input changes into account.
        //
        // So these methods can be triggered multiple times with same values,
        // but it doesn't matter as they are idempotent.
        this.updateHeaderExpandProperties();
        // Whenever expandable mode is changed, update certain properties & hooks.
        if (changes.expandable) {
          this.updateHeaderExpandChangeHook();
          this.checkHeaderElemPlacement();
        }
      }
    }
    ngOnInit() {}
    ngOnDestroy() {
      this.headerExpandChangeSubscription?.unsubscribe();
    }
    expandCollapseDone(event) {
      // fromState check is also necessary as void => state is triggered on initial draw
      if (event.fromState === 'collapsed' && event.toState === 'expanded') {
        this.afterExpand.emit();
      } else if (event.fromState === 'expanded' && event.toState === 'collapsed') {
        this.afterCollapse.emit();
      }
    }
    updateHeaderExpandProperties() {
      this.headerComponent?.updateExpandProperties({
        expandable: this.expandable,
        expandDisabled: this.expandDisabled,
        expanded: this.expanded
      });
    }
    updateHeaderExpandChangeHook() {
      // Unsubscribe from possible previous change subscription
      this.headerExpandChangeSubscription?.unsubscribe();
      // The change hook is only inserted if expand is activated
      if (this.expandable) {
        this.headerExpandChangeSubscription = this.headerComponent?.expandChangeSubject.subscribe(expanded => {
          this.expanded = expanded;
          if (this.expanded) {
            this.opened.emit();
          } else {
            this.closed.emit();
          }
          this.cdRef.markForCheck();
        });
      }
    }
    checkHeaderElemPlacement() {
      if (this.expandable) {
        if (this.headerElemRef && !this.headerElemRef.nativeElement.parentElement.className.includes('card-container')) {
          console.error('[HPO Card]', 'Card header is not placed directly under card component and expandable mode is enabled. Expand wont work properly.', 'Parent element:', this.hostElemRef.nativeElement.parentElement);
        }
      }
    }
    static {
      this.ɵfac = function CardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardComponent,
        selectors: [["hpo-card"]],
        contentQueries: function CardComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CardHeaderComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, CardHeaderComponent, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerComponentSet = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerElemRefSet = _t.first);
          }
        },
        inputs: {
          mobile: "mobile",
          expandable: "expandable",
          expandDisabled: "expandDisabled",
          expanded: "expanded"
        },
        outputs: {
          opened: "opened",
          closed: "closed",
          afterExpand: "afterExpand",
          afterCollapse: "afterCollapse"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c10,
        decls: 4,
        vars: 5,
        consts: [[1, "card-container", 3, "ngClass"], [1, "content-container"]],
        template: function CardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c9);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementStart(2, "div", 1);
            i0.ɵɵlistener("@expandCollapse.done", function CardComponent_Template_div_animation_expandCollapse_done_2_listener($event) {
              return ctx.expandCollapseDone($event);
            });
            i0.ɵɵprojection(3, 1);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c11, !ctx.mobile, ctx.mobile));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("@expandCollapse", ctx.expandState);
          }
        },
        dependencies: [i1.NgClass],
        styles: [".card-container[_ngcontent-%COMP%]{color:#000000de;background-color:#fff;overflow:hidden}.card-container.desktop[_ngcontent-%COMP%]{border:1px solid rgba(0,0,0,.09);margin:.8rem .8rem 1.6rem;border-radius:.3rem}.card-container.mobile[_ngcontent-%COMP%]{box-shadow:0 0 2px #00003252;width:100%;margin:0 0 1.6rem;border-radius:.2rem}.card-container[_ngcontent-%COMP%]   .content-container[_ngcontent-%COMP%]{min-height:0;overflow:hidden}"],
        data: {
          animation: [trigger('expandCollapse', [state('collapsed', style({
            height: 0
          })), state('expanded', style({
            height: '*'
          })), transition('collapsed <=> expanded', animate('300ms cubic-bezier(0.645, 0.045, 0.355, 1)'))])]
        },
        changeDetection: 0
      });
    }
  }
  return CardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardActionsComponent = /*#__PURE__*/(() => {
  class CardActionsComponent {
    constructor() {}
    static {
      this.ɵfac = function CardActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardActionsComponent,
        selectors: [["hpo-card-actions"]],
        ngContentSelectors: _c8,
        decls: 2,
        vars: 0,
        consts: [[1, "actions"]],
        template: function CardActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".actions[_ngcontent-%COMP%]{margin:.8rem}"],
        changeDetection: 0
      });
    }
  }
  return CardActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardContentComponent = /*#__PURE__*/(() => {
  class CardContentComponent {
    constructor() {}
    static {
      this.ɵfac = function CardContentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardContentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardContentComponent,
        selectors: [["hpo-card-content"]],
        ngContentSelectors: _c8,
        decls: 2,
        vars: 0,
        consts: [[1, "content"]],
        template: function CardContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".content[_ngcontent-%COMP%]{margin:1.6rem}"],
        changeDetection: 0
      });
    }
  }
  return CardContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardModule = /*#__PURE__*/(() => {
  class CardModule {
    static {
      this.ɵfac = function CardModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CardModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatIconModule]
      });
    }
  }
  return CardModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MY_FORMATS = {
  parse: {
    dateInput: ['L',
    // Locale specific format
    'DD-MM-YYYY', 'DD/MM/YYYY', 'DD.MM.YYYY', 'DD MM YYYY', 'DD:MM:YYYY',
    // DDMMYYYY
    'D-M-YYYY', 'D/M/YYYY', 'D.M.YYYY', 'D M YYYY', 'D:M:YYYY',
    // DMYYYY
    'DD-MM-YY', 'DD/MM/YY', 'DD.MM.YY', 'DD MM YY', 'DD:MM:YY',
    // DDMMYY
    'D-M-YY', 'D/M/YY', 'D.M.YY', 'D M YY', 'D:M:YY',
    // DMYY
    'DD-MM', 'DD/MM', 'DD.MM', 'DD MM', 'DD:MM',
    // DDMM
    'D-M', 'D/M', 'D.M', 'D M', 'D:M',
    // DM
    'D',
    // Single day
    'DDMMYYYY', 'DMYYYY', 'DDMMYY', 'DMYY', 'DDMM' // Without delimiters
    ]
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
const MY_OPTIONS = {
  strict: true,
  useUtc: false
};
let DatetimepickerComponent = /*#__PURE__*/(() => {
  class DatetimepickerComponent {
    set value(value) {
      if (dayjs(value).isValid()) {
        this.dateValue = value ? dayjs(value) : null;
        this.timeValue = value ? dayjs(value) : null;
      }
      if (value == null) {
        this.dateValue = null;
        this.timeValue = null;
      } else {
        // This change is particular to IWD where the backend serialization of json changes the date format.
        let changedDate = dayjs.utc(this.dateValue, 'DD.MM.YYYY HH.mm.ss').toDate();
        if (dayjs(changedDate).isValid()) {
          this.dateValue = changedDate ? dayjs(changedDate) : null;
          this.timeValue = changedDate ? dayjs(changedDate) : null;
        }
      }
    }
    constructor(blahService, adapter) {
      this.blahService = blahService;
      this.adapter = adapter;
      this.destroy$ = new Subject();
      this.disabled = false;
      this.hideTimeInput = false; // Variable to hide/show time input
      this.hideClearIcon = false; // Variable to hide/show clear Icon
      this.touch = false;
      this.required = false;
      this.endOfDayTime = false; // Changes current time to 23:59 if not set
      this.valueChange = new EventEmitter();
      this.errorState = new EventEmitter();
      this.showErrorHint = false;
      this.lastChangedInputType = null;
      // dateClass loops through days in month view
      this.dateClass = (cellDate, view) => {
        if (view === 'month') {
          const day = dayjs(cellDate).day();
          const isoWeekNumber = dayjs(cellDate).isoWeek();
          const date = dayjs(cellDate).date();
          const month = dayjs(cellDate).month() + 1;
          const year = dayjs(cellDate).year();
          // Find the first day of the month
          const startOfMonth = dayjs(cellDate).startOf('month');
          const startDayOfWeek = startOfMonth.day();
          let prefix = '';
          // Add the week number class for the first visible Monday or start of the month
          if (day === 1) {
            prefix = 'show-iso-week' + (this.touch ? '-touch ' : ' ') + 'iso-week-' + isoWeekNumber + ' ';
          }
          // Add the week number class for the midweeks and date indent class
          if (date <= 7 && day === startDayOfWeek) {
            prefix = 'show-iso-week' + (this.touch ? '-touch ' : ' ') + 'iso-week-' + isoWeekNumber + ' date-indent-' + day + (this.touch ? '-touch' : '') + ' ';
          }
          // Changing year as datepickers year changes
          if (this.datePickerYear != year) {
            this.holidays = getHolidayDates(year);
            this.datePickerYear = year;
          }
          //Check if holiday
          if (this.holidays.find(holidayDate => holidayDate.year == year && holidayDate.month == month && holidayDate.date == date)) {
            return prefix + "holiday";
          }
          return prefix;
        }
        return '';
      };
      this.holidays = getHolidayDates();
      this.datePickerYear = dayjs().year();
    }
    ngOnInit() {
      this.adapter.setLocale(this.blahService.currentLocale);
      this.blahService.localeChange$.pipe(takeUntil(this.destroy$)).subscribe(newLocale => {
        this.adapter.setLocale(newLocale);
      });
    }
    /**
     * Handle changes in validation input parameters
     */
    ngOnChanges(changes) {
      if (changes.required || changes.min || changes.max) {
        var firstChange = changes.required && changes.required.firstChange || changes.min && changes.min.firstChange || changes.max && changes.max.firstChange;
        this.checkErrorState(!!this.dateValue ? this.getDateTime() : null, firstChange);
      }
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    get TimeInputValue() {
      if (this.timeValue == null) {
        return '';
      }
      // Format time to H:mm
      return this.timeValue.format('H:mm');
    }
    set TimeInputValue(v) {
      if (v === '') {
        this.timeValue = null;
      } else {
        // Parse time from one of these formats
        let parsedValue = dayjs(v, ['HHmm', 'HH:mm', 'Hm', 'H']);
        if (!parsedValue.isValid()) {
          this.timeValue = null;
        } else {
          this.timeValue = parsedValue;
        }
      }
      this.onChange();
    }
    onTimeInputValueChange(event) {
      this.lastChangedInputType = 'TIME';
      const input = event.target;
      this.TimeInputValue = input.value;
      // reset input if the timeValue is null already
      if (this.timeValue == null) {
        input.value = '';
      }
    }
    onDateChange(event) {
      const inputValue = event.targetElement.value;
      // Only send events if input is empty or valid and parsed
      if (this.dateValue || inputValue === '') {
        this.lastChangedInputType = 'DATE';
        this.onChange();
      }
    }
    onChange() {
      if (this.dateValue != null) {
        const value = this.getDateTime();
        this.valueChange.emit(value.toISOString());
        this.checkErrorState(value);
      } else {
        this.valueChange.emit(null);
        this.checkErrorState();
      }
    }
    /**
     * Sets current time and date as the input value
     */
    setCurrentTime() {
      if (!this.disabled) {
        const time = dayjs().second(0).millisecond(0);
        this.dateValue = time;
        this.timeValue = time;
        this.lastChangedInputType = 'TIME';
        this.onChange();
      }
    }
    /**
     * Maps time input value to date input value
     */
    getDateTime() {
      let value = dayjs(this.dateValue);
      if (this.lastChangedInputType === 'DATE') {
        this.validateTimeValue();
      }
      if (this.timeValue != null) {
        value = value.hour(this.timeValue.hour()).minute(this.timeValue.minute());
      }
      return value;
    }
    validateTimeValue() {
      if (this.endOfDayTime && !this.timeValue) {
        this.timeValue = dayjs(this.dateValue).endOf('day'); // set the time to 23:59 if not set
      }
    }
    /**
     * Emits error state to parent and shows error mat-hint if needed
     */
    checkErrorState(inputDateTime = null, firstChange = false) {
      if (!this.required && !this.min && !this.max) {
        this.errorState.emit(false);
        this.showErrorHint = false;
        return;
      }
      var hasErrors = !inputDateTime && this.required || !!this.min && inputDateTime < dayjs(this.min).second(0).millisecond(0) || !!this.max && inputDateTime > dayjs(this.max).second(0).millisecond(0);
      this.errorState.emit(hasErrors);
      // do not show error when component initializes (emit error state though)
      this.showErrorHint = firstChange ? false : hasErrors;
    }
    static {
      this.ɵfac = function DatetimepickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DatetimepickerComponent)(i0.ɵɵdirectiveInject(i1$1.BlahService), i0.ɵɵdirectiveInject(i2$1.DateAdapter));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DatetimepickerComponent,
        selectors: [["hpo-datetimepicker"]],
        inputs: {
          id: "id",
          disabled: "disabled",
          datePlaceholder: "datePlaceholder",
          timePlaceholder: "timePlaceholder",
          hideTimeInput: "hideTimeInput",
          hideClearIcon: "hideClearIcon",
          touch: "touch",
          required: "required",
          min: "min",
          max: "max",
          errorMessage: "errorMessage",
          endOfDayTime: "endOfDayTime",
          startAtDate: "startAtDate",
          value: "value"
        },
        outputs: {
          valueChange: "valueChange",
          errorState: "errorState"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: DateAdapter,
          useClass: DayjsDateAdapter,
          deps: [MAT_DATE_LOCALE]
        }, {
          provide: MAT_DATE_FORMATS,
          useValue: MY_FORMATS
        }, {
          provide: MAT_DAYJS_DATE_ADAPTER_OPTIONS,
          useValue: MY_OPTIONS
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 10,
        vars: 20,
        consts: [["picker", ""], [1, "flex-container", 3, "id"], [1, "datefield"], [1, "hpo-datetimepicker-form-field", "input", 3, "ngClass"], ["matInput", "", 3, "ngModelChange", "dateChange", "id", "disabled", "matDatepicker", "ngModel", "required", "min", "max", "maxLength"], [1, "hpo-datetimepicker-error-hint"], ["startView", "month", "panelClass", "hpo-datepicker-panel", 3, "touchUi", "startAt", "dateClass"], ["matSuffix", ""], [1, "timefield"], ["matSuffix", "", 3, "click"], [1, "input", "hpo-datetimepicker-form-field", 3, "ngClass"], ["matInput", "", "type", "text", "matInput", "", 3, "change", "id", "disabled", "value", "maxLength"]],
        template: function DatetimepickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "mat-form-field", 3);
            i0.ɵɵtemplate(3, DatetimepickerComponent_Conditional_3_Template, 2, 1, "mat-label");
            i0.ɵɵelementStart(4, "input", 4);
            i0.ɵɵtwoWayListener("ngModelChange", function DatetimepickerComponent_Template_input_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.dateValue, $event) || (ctx.dateValue = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("dateChange", function DatetimepickerComponent_Template_input_dateChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDateChange($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, DatetimepickerComponent_Conditional_5_Template, 2, 1, "mat-hint", 5);
            i0.ɵɵelement(6, "mat-datepicker", 6, 0);
            i0.ɵɵtemplate(8, DatetimepickerComponent_Conditional_8_Template, 2, 0, "mat-icon", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, DatetimepickerComponent_Conditional_9_Template, 5, 10, "div", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const picker_r4 = i0.ɵɵreference(7);
            i0.ɵɵpropertyInterpolate("id", ctx.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c12, ctx.showErrorHint));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.datePlaceholder ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("id", "", ctx.id, "-date");
            i0.ɵɵproperty("disabled", ctx.disabled)("matDatepicker", picker_r4);
            i0.ɵɵtwoWayProperty("ngModel", ctx.dateValue);
            i0.ɵɵproperty("required", ctx.required)("min", ctx.min)("max", ctx.max)("maxLength", 20);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showErrorHint ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("touchUi", ctx.touch)("startAt", !ctx.dateValue ? ctx.startAtDate : ctx.dateValue)("dateClass", ctx.dateClass);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.disabled ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.hideTimeInput ? 9 : -1);
          }
        },
        dependencies: [i1.NgClass, i4.DefaultValueAccessor, i4.NgControlStatus, i4.RequiredValidator, i4.NgModel, i5$1.MatDatepicker, i5$1.MatDatepickerInput, i2$2.MatInput, i3$1.MatFormField, i3$1.MatLabel, i3$1.MatHint, i3$1.MatSuffix, i3$2.MatIcon],
        styles: [".flex-container[_ngcontent-%COMP%]{width:100%;display:flex;flex-direction:row;flex-wrap:wrap;align-items:stretch}.datefield[_ngcontent-%COMP%]{width:120px;flex-grow:2;padding-right:5px}.timefield[_ngcontent-%COMP%]{width:80px;flex-grow:1}*[_ngcontent-%COMP%]:disabled{color:#4b4b4b!important}.buttons[_ngcontent-%COMP%]{width:40px;flex-grow:0}.input[_ngcontent-%COMP%]{width:100%}  .mat-datepicker-content-touch{padding-right:40px;padding-left:5%;place-content:center}  .mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:#c5cae9!important}  .hpo-datepicker-panel{padding-left:40px}  .hpo-datepicker-panel button.holiday{background:#ffe2e6;border-radius:100%}  .hpo-datepicker-panel button .mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:#3f51b5}  .hpo-datepicker-panel button.show-iso-week:before{position:absolute;font-size:10pt;margin-left:-40px;color:gray;text-align:center;border-right:solid lightgray 1px;padding:18px 0 25px 15px}  .hpo-datepicker-panel button.show-iso-week-touch:before{position:inherit;font-size:10pt;margin-left:-100%;color:gray;text-align:center;padding:50%;border-right:solid lightgray 1px}  .hpo-datepicker-panel button.date-indent-2:before{margin-left:-80px!important}  .hpo-datepicker-panel button.date-indent-3:before{margin-left:-120px!important}  .hpo-datepicker-panel button.date-indent-4:before{margin-left:-160px!important}  .hpo-datepicker-panel button.date-indent-5:before{margin-left:-200px!important}  .hpo-datepicker-panel button.date-indent-6:before{margin-left:-240px!important}  .hpo-datepicker-panel button.date-indent-0:before{margin-left:-280px!important}  .hpo-datepicker-panel button.date-indent-1-touch:before{margin-left:-100%!important}  .hpo-datepicker-panel button.date-indent-2-touch:before{margin-left:-200%!important}  .hpo-datepicker-panel button.date-indent-3-touch:before{margin-left:-300%!important}  .hpo-datepicker-panel button.date-indent-4-touch:before{margin-left:-400%!important}  .hpo-datepicker-panel button.date-indent-5-touch:before{margin-left:-500%!important}  .hpo-datepicker-panel button.date-indent-6-touch:before{margin-left:-600%!important}  .hpo-datepicker-panel button.date-indent-0-touch:before{margin-left:-700%!important}  .hpo-datepicker-panel button.iso-week-1:before{content:\"01\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-2:before{content:\"02\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-3:before{content:\"03\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-4:before{content:\"04\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-5:before{content:\"05\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-6:before{content:\"06\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-7:before{content:\"07\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-8:before{content:\"08\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-9:before{content:\"09\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-10:before{content:\"10\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-11:before{content:\"11\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-12:before{content:\"12\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-13:before{content:\"13\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-14:before{content:\"14\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-15:before{content:\"15\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-16:before{content:\"16\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-17:before{content:\"17\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-18:before{content:\"18\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-19:before{content:\"19\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-20:before{content:\"20\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-21:before{content:\"21\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-22:before{content:\"22\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-23:before{content:\"23\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-24:before{content:\"24\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-25:before{content:\"25\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-26:before{content:\"26\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-27:before{content:\"27\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-28:before{content:\"28\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-29:before{content:\"29\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-30:before{content:\"30\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-31:before{content:\"31\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-32:before{content:\"32\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-33:before{content:\"33\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-34:before{content:\"34\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-35:before{content:\"35\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-36:before{content:\"36\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-37:before{content:\"37\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-38:before{content:\"38\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-39:before{content:\"39\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-40:before{content:\"40\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-41:before{content:\"41\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-42:before{content:\"42\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-43:before{content:\"43\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-44:before{content:\"44\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-45:before{content:\"45\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-46:before{content:\"46\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-47:before{content:\"47\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-48:before{content:\"48\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-49:before{content:\"49\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-50:before{content:\"50\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-51:before{content:\"51\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-52:before{content:\"52\";display:flex;align-items:center}  .hpo-datepicker-panel button.iso-week-53:before{content:\"53\";display:flex;align-items:center}"]
      });
    }
  }
  return DatetimepickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const getHolidayDates = (year = dayjs().year()) => {
  // Static holidays
  let holidays = [{
    year,
    month: 1,
    date: 1
  }, {
    year,
    month: 1,
    date: 6
  }, {
    year,
    month: 5,
    date: 1
  }, {
    year,
    month: 12,
    date: 6
  }, {
    year,
    month: 12,
    date: 24
  }, {
    year,
    month: 12,
    date: 25
  }, {
    year,
    month: 12,
    date: 26
  }];
  // Midsummer (Juhannus)
  let tempDate = new Date(year, 5, 19);
  addMiscHoliday(tempDate, 5, holidays);
  addMiscHoliday(tempDate, 6, holidays);
  // All saint's day (Pyhäinpäivä)
  tempDate.setMonth(9, 31);
  addMiscHoliday(tempDate, 6, holidays);
  // Easter and related days by Gauss' formula
  let easterDate,
    easterMonth = 3;
  const a = year % 19;
  const b = year % 4;
  const c = year % 7;
  const d = (24 + 19 * a) % 30;
  const e = (5 + 2 * b + 4 * c + 6 * d) % 7;
  const f = 22 + d + e;
  // If easter is in March
  if (f <= 31) {
    easterMonth = 2;
    easterDate = f;
  }
  // If easter is in April
  else {
    const g = d + e - 9;
    // Exception 1: if g = 26 -> easter is 19.4.
    if (g == 26) {
      easterDate = 19;
    }
    // Exception 2: if g = 25, d = 28 ja a > 10 -> easter is 18.4.
    else if (g == 25 && d == 28 && a > 10) {
      easterDate = 18;
    } else {
      easterDate = g;
    }
  }
  tempDate.setMonth(easterMonth, easterDate);
  addDiffHoliday(tempDate, -2, holidays); // Pitkäperjantai
  addHoliday(tempDate, holidays); // Pääsiäissunnuntai
  addDiffHoliday(tempDate, 1, holidays); // 2. Pääsiäispäivä
  addDiffHoliday(tempDate, 39, holidays); // Helatorstai
  return holidays;
};
// Adding holiday thats on specific weekday 
function addMiscHoliday(tDate, weekday, holidays) {
  const cDate = new Date(tDate);
  let diff = weekday - cDate.getDay();
  if (diff < 0) diff += 7;
  cDate.setDate(cDate.getDate() + diff);
  addHoliday(cDate, holidays);
}
;
// Adds holiday to holidays array
const addHoliday = (dayjsDate, holidays) => {
  const date = dayjs(dayjsDate).date();
  const month = dayjs(dayjsDate).month() + 1;
  const year = dayjs(dayjsDate).year();
  const dateObj = {
    date,
    month,
    year
  };
  holidays.push(dateObj);
};
// Adding holiday that depends on other holiday dates
const addDiffHoliday = (tDate, diff, holidays) => {
  const cDate = new Date(tDate);
  cDate.setDate(cDate.getDate() + diff);
  addHoliday(cDate, holidays);
};
let DatetimepickerModule = /*#__PURE__*/(() => {
  class DatetimepickerModule {
    static {
      this.ɵfac = function DatetimepickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DatetimepickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DatetimepickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, MatDatepickerModule, MatInputModule, MatIconModule, MatButtonModule]
      });
    }
  }
  return DatetimepickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListComponent = /*#__PURE__*/(() => {
  class ListComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function ListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ListComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListComponent,
        selectors: [["hpo-list"]],
        ngContentSelectors: _c8,
        decls: 2,
        vars: 0,
        consts: [[1, "list"]],
        template: function ListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".list[_ngcontent-%COMP%]{border-top:1px solid #EEE;display:flex;flex-direction:column}"],
        changeDetection: 0
      });
    }
  }
  return ListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListItemComponent = /*#__PURE__*/(() => {
  class ListItemComponent {
    constructor() {
      this.expandable = false;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function ListItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ListItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ListItemComponent,
        selectors: [["hpo-list-item"]],
        inputs: {
          expandable: "expandable"
        },
        ngContentSelectors: _c8,
        decls: 2,
        vars: 0,
        consts: [[1, "list-item"]],
        template: function ListItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".list-item[_ngcontent-%COMP%]{font-weight:500;border-bottom:1px solid #EEE;padding:1.6rem;justify-content:center;flex-grow:1}"]
      });
    }
  }
  return ListItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ListModule = /*#__PURE__*/(() => {
  class ListModule {
    static {
      this.ɵfac = function ListModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ListModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ListModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return ListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputComponent = /*#__PURE__*/(() => {
  class InputComponent {
    constructor() {
      this.focus = false;
      this.floatLabel = 'auto';
      this.id = '';
      this.value = '';
      this.placeholder = '';
      this.type = 'text';
      this.disabled = false;
      this.readonly = false;
      this.maxlength = null;
      this.valueChange = new EventEmitter();
    }
    /**
     * Called when component value changes
     * */
    onChange(evt) {
      this.valueChange.emit(evt.target.value);
    }
    ngOnChanges() {
      this.floatLabel = this.readonly ? 'always' : 'auto';
    }
    ngOnInit() {}
    static {
      this.ɵfac = function InputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputComponent,
        selectors: [["hpo-input"]],
        inputs: {
          id: "id",
          value: "value",
          placeholder: "placeholder",
          type: "type",
          disabled: "disabled",
          readonly: "readonly",
          maxlength: "maxlength"
        },
        outputs: {
          valueChange: "valueChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 12,
        consts: [[3, "ngClass", "floatLabel"], ["matInput", "", 3, "change", "keyup", "focus", "blur", "id", "value", "type", "disabled", "readonly"], ["align", "end"]],
        template: function InputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0);
            i0.ɵɵtemplate(1, InputComponent_Conditional_1_Template, 2, 1, "mat-label");
            i0.ɵɵelementStart(2, "input", 1);
            i0.ɵɵlistener("change", function InputComponent_Template_input_change_2_listener($event) {
              return ctx.onChange($event);
            })("keyup", function InputComponent_Template_input_keyup_2_listener($event) {
              return ctx.onChange($event);
            })("focus", function InputComponent_Template_input_focus_2_listener() {
              return ctx.focus = true;
            })("blur", function InputComponent_Template_input_blur_2_listener() {
              return ctx.focus = false;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, InputComponent_Conditional_3_Template, 2, 2, "mat-hint", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c13, ctx.readonly))("floatLabel", ctx.floatLabel);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.placeholder ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("id", ctx.id)("value", ctx.value)("type", ctx.type)("disabled", ctx.disabled)("readonly", ctx.readonly);
            i0.ɵɵattribute("maxlength", ctx.maxlength);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.focus && ctx.maxlength != null && !ctx.readonly ? 3 : -1);
          }
        },
        dependencies: [i1.NgClass, i2$2.MatInput, i3$1.MatFormField, i3$1.MatLabel, i3$1.MatHint],
        styles: [".mat-mdc-input-element[_ngcontent-%COMP%]:read-only{cursor:default}.mat-mdc-form-field.read-only[_ngcontent-%COMP%]     .mdc-line-ripple{display:none}"],
        changeDetection: 0
      });
    }
  }
  return InputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputModule = /*#__PURE__*/(() => {
  class InputModule {
    static {
      this.ɵfac = function InputModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: InputModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatInputModule]
      });
    }
  }
  return InputModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BottomSheetComponent = /*#__PURE__*/(() => {
  class BottomSheetComponent {
    constructor(cdRef) {
      this.cdRef = cdRef;
      this.closed = new EventEmitter();
      this.active = false;
    }
    open() {
      this.active = true;
      this.cdRef.markForCheck();
    }
    close() {
      this.active = false;
      this.cdRef.markForCheck();
    }
    sheetStateChanged(event) {
      if (event.toState === 'void') {
        setTimeout(() => this.closed.emit());
      }
    }
    static {
      this.ɵfac = function BottomSheetComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BottomSheetComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BottomSheetComponent,
        selectors: [["hpo-bottom-sheet"]],
        inputs: {
          label: "label"
        },
        outputs: {
          closed: "closed"
        },
        ngContentSelectors: _c8,
        decls: 2,
        vars: 2,
        consts: [["class", "screen-overlay", 3, "click", 4, "ngIf"], ["class", "bottom-sheet", 4, "ngIf"], [1, "screen-overlay", 3, "click"], [1, "bottom-sheet"], ["class", "bottom-sheet-label", 4, "ngIf"], [1, "bottom-sheet-label"]],
        template: function BottomSheetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, BottomSheetComponent_div_0_Template, 1, 1, "div", 0)(1, BottomSheetComponent_div_1_Template, 3, 2, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.active);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.active);
          }
        },
        dependencies: [i1.NgIf],
        styles: [".screen-overlay[_ngcontent-%COMP%]{background-color:#0003;z-index:1000;margin:auto;position:fixed;inset:0}.bottom-sheet[_ngcontent-%COMP%]{background-color:#fff;position:fixed;left:0;right:0;bottom:0;padding:.8rem 0;max-height:calc(100vh - 10rem);box-shadow:0 0 5px -1px #00000080;overflow-y:auto;z-index:1500}.bottom-sheet-label[_ngcontent-%COMP%]{height:5.6rem;font-size:1.6rem;color:#0000008a;display:flex;align-items:center;margin-top:-.8rem;padding:0 1.6rem;overflow:hidden;white-space:nowrap}"],
        data: {
          animation: [trigger('overlayState', [state('void', style({
            opacity: 0
          })), state('*', style({
            opacity: 1
          })), transition(':enter', animate('225ms ease-out')), transition(':leave', animate('195ms ease-in'))]), trigger('sheetState', [state('void', style({
            transform: 'translateY(100%)'
          })), state('*', style({
            transform: 'translateY(0)'
          })), transition(':enter', animate('225ms ease-out')), transition(':leave', animate('195ms ease-in'))])]
        },
        changeDetection: 0
      });
    }
  }
  return BottomSheetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SheetItemComponent = /*#__PURE__*/(() => {
  class SheetItemComponent {
    constructor(sheet) {
      this.sheet = sheet;
    }
    static {
      this.ɵfac = function SheetItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SheetItemComponent)(i0.ɵɵdirectiveInject(BottomSheetComponent));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SheetItemComponent,
        selectors: [["hpo-sheet-item"]],
        inputs: {
          icon: "icon"
        },
        ngContentSelectors: _c8,
        decls: 8,
        vars: 2,
        consts: [["sheetItem", ""], [1, "sheet-item", 3, "click"], ["matRipple", "", 1, "sheet-item-ripple", 3, "matRippleTrigger"], [1, "sheet-item-icon"], [1, "sheet-item-text"]],
        template: function SheetItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵlistener("click", function SheetItemComponent_Template_div_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.sheet.close());
            });
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "mat-icon");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const sheetItem_r2 = i0.ɵɵreference(1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("matRippleTrigger", sheetItem_r2);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.icon);
          }
        },
        dependencies: [i3$2.MatIcon, i2$1.MatRipple],
        styles: ["[_nghost-%COMP%]{-webkit-tap-highlight-color:rgba(0,0,0,0);outline:none}.sheet-item[_ngcontent-%COMP%]{height:4.8rem;position:relative;display:flex;flex-direction:row;align-items:center;font-size:1.6rem;padding:0 1.6rem;cursor:pointer;overflow:hidden;white-space:nowrap}.sheet-item[_ngcontent-%COMP%]:active, .sheet-item[_ngcontent-%COMP%]:hover{background-color:#0000000a}.sheet-item-icon[_ngcontent-%COMP%]{width:2.4rem;height:2.4rem;color:#0000008a}.sheet-item-text[_ngcontent-%COMP%]{margin-left:3.2rem;color:#000000de}.sheet-item-ripple[_ngcontent-%COMP%]{inset:0;position:absolute;pointer-events:none}"],
        changeDetection: 0
      });
    }
  }
  return SheetItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SheetDividerComponent = /*#__PURE__*/(() => {
  class SheetDividerComponent {
    static {
      this.ɵfac = function SheetDividerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SheetDividerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SheetDividerComponent,
        selectors: [["hpo-sheet-divider"]],
        decls: 1,
        vars: 0,
        consts: [[1, "sheet-divider"]],
        template: function SheetDividerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
        },
        styles: [".sheet-divider[_ngcontent-%COMP%]{margin:.7rem 0 .8rem;border-top:1px solid rgba(0,0,0,.12)}"],
        changeDetection: 0
      });
    }
  }
  return SheetDividerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SheetActionsComponent = /*#__PURE__*/(() => {
  class SheetActionsComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function SheetActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SheetActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SheetActionsComponent,
        selectors: [["hpo-sheet-actions"]],
        ngContentSelectors: _c8,
        decls: 2,
        vars: 0,
        consts: [[1, "sheet-actions"]],
        template: function SheetActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".sheet-actions[_ngcontent-%COMP%]{text-align:right;padding:.8rem 1.6rem}"],
        changeDetection: 0
      });
    }
  }
  return SheetActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SheetContentComponent = /*#__PURE__*/(() => {
  class SheetContentComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function SheetContentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SheetContentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SheetContentComponent,
        selectors: [["hpo-sheet-content"]],
        ngContentSelectors: _c8,
        decls: 2,
        vars: 0,
        consts: [[1, "sheet-content"]],
        template: function SheetContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        styles: [".sheet-content[_ngcontent-%COMP%]{padding:.8rem 1.6rem}"],
        changeDetection: 0
      });
    }
  }
  return SheetContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BottomSheetModule = /*#__PURE__*/(() => {
  class BottomSheetModule {
    static {
      this.ɵfac = function BottomSheetModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BottomSheetModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BottomSheetModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule, MatRippleModule]
      });
    }
  }
  return BottomSheetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BottomNavComponent = /*#__PURE__*/(() => {
  class BottomNavComponent {
    static {
      this.ɵfac = function BottomNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BottomNavComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BottomNavComponent,
        selectors: [["hpo-bottom-nav"]],
        ngContentSelectors: _c8,
        decls: 3,
        vars: 0,
        consts: [[1, "bottom-nav-container"], [1, "bottom-nav-spacer"]],
        template: function BottomNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "div", 1);
          }
        },
        styles: ["@media print{[_nghost-%COMP%]{display:none!important}}.bottom-nav-container[_ngcontent-%COMP%]{position:fixed;z-index:800;bottom:0;left:0;right:0;background-color:#fff;margin:0;box-shadow:0 0 .4rem #0000001f;display:flex;flex-direction:row;width:100%;height:5.6rem}.bottom-nav-spacer[_ngcontent-%COMP%]{height:5.6rem;float:left}"],
        changeDetection: 0
      });
    }
  }
  return BottomNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NavItemComponent = /*#__PURE__*/(() => {
  class NavItemComponent {
    static {
      this.ɵfac = function NavItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NavItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NavItemComponent,
        selectors: [["hpo-nav-item"]],
        inputs: {
          icon: "icon",
          active: "active"
        },
        ngContentSelectors: _c8,
        decls: 7,
        vars: 7,
        consts: [["navItem", ""], [1, "nav-item", 3, "ngClass"], ["matRipple", "", 1, "nav-item-ripple", 3, "matRippleCentered", "matRippleRadius", "matRippleTrigger"], [1, "nav-item-text"]],
        template: function NavItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵelementStart(3, "mat-icon");
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵprojection(6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const navItem_r1 = i0.ɵɵreference(1);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c14, ctx.active));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("matRippleCentered", true)("matRippleRadius", 60)("matRippleTrigger", navItem_r1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.icon);
          }
        },
        dependencies: [i1.NgClass, i3$2.MatIcon, i2$1.MatRipple],
        styles: ["[_nghost-%COMP%]{-webkit-tap-highlight-color:rgba(0,0,0,0);outline:none;flex:1;overflow:hidden}.nav-item[_ngcontent-%COMP%]{position:relative;font-size:1.2rem;line-height:1.4;white-space:nowrap;color:#0000008a;padding:.6rem 1rem .8rem;text-align:center;cursor:pointer;transition:all ease-in-out .1s}.nav-item[_ngcontent-%COMP%]:active, .nav-item[_ngcontent-%COMP%]:hover, .nav-item-active[_ngcontent-%COMP%]{font-size:1.4rem;line-height:1.22}.nav-item-ripple[_ngcontent-%COMP%]{inset:0;position:absolute;pointer-events:none}"],
        changeDetection: 0
      });
    }
  }
  return NavItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BottomNavModule = /*#__PURE__*/(() => {
  class BottomNavModule {
    static {
      this.ɵfac = function BottomNavModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BottomNavModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BottomNavModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule, MatRippleModule]
      });
    }
  }
  return BottomNavModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MapComponent = /*#__PURE__*/(() => {
  class MapComponent {
    constructor(cdRef) {
      this.cdRef = cdRef;
      this.latitude = 0;
      this.longitude = 0;
      this.longestSide = 0;
      this.height = 0;
      this.aspectRatio = {
        width: 1,
        height: 1
      };
      // VM variables
      this.mapImage = '';
      this.coordinatesValid = false;
      this.backendUri = `https://backend.headpower.fi/Map.BackEnd/CommonMapWebAPI/api/Map/GetMapImage`;
      this.destroy$ = new Subject();
      this.height$ = new BehaviorSubject(0);
      this.firstChange = true;
    }
    onResize() {
      // Announce new height of the container after rezise
      setTimeout(() => {
        this.height$.next(this.calculateHeight(this.map.nativeElement.offsetWidth, this.aspectRatio));
      });
    }
    /**
     * Create initial subscription to container height
     */
    ngAfterViewInit() {
      this.height$.next(this.calculateHeight(this.map.nativeElement.offsetWidth, this.aspectRatio));
      setTimeout(() => {
        // Subscribe for container height changes
        this.height$.pipe(takeUntil(this.destroy$)).subscribe(height => {
          if (height) {
            this.height = height;
            this.cdRef.markForCheck();
          }
        });
        // Wait for a moment before reloading image after latest emitted value
        this.height$.pipe(debounceTime(500)).pipe(takeUntil(this.destroy$)).subscribe(height => {
          // set image for the container element
          if (this.isValidCoordinates(this.latitude, this.longitude)) {
            // Changes for assisting map component in Ionic mobile
            let width = 0;
            if (!height) {
              height = this.height;
            }
            if (this.map.nativeElement.offsetWidth) {
              width = this.map.nativeElement.offsetWidth;
            } else {
              width = this.aspectRatio.width / this.aspectRatio.height * height;
            }
            this.mapImage = this.getMapUrl(width, height, this.longestSide, this.latitude, this.longitude);
            this.cdRef.markForCheck();
          }
        });
      });
    }
    /**
     * Update component when inputs change
     * @param changes
     */
    ngOnChanges(changes) {
      if (!this.firstChange) {
        // Needed to announce new size after component inputs change
        this.height$.next(this.calculateHeight(this.map.nativeElement.offsetWidth, this.aspectRatio));
      }
      this.isValidCoordinates(this.latitude, this.longitude);
      this.firstChange = false;
    }
    /**
     * Clean up on destroy
     */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
     * Checks coordinate validity
     */
    isValidCoordinates(latitude, longitude) {
      let result = true;
      if (isNaN(latitude) || isNaN(longitude)) {
        result = false;
      }
      if (latitude === null || longitude === null) {
        result = false;
      }
      this.coordinatesValid = result;
      this.cdRef.markForCheck();
      return result;
    }
    /**
     * Creates an url for requesting a map
     * @param width Width of the container in pixels
     * @param height Height of the container in pixels
     * @param longestSide Area distance of the longest side
     * @param latitude Y-axis point of the map
     * @param longitude X-axis point of the map
     * @returns Url of the image
     */
    getMapUrl(width, height, longestSide, latitude, longitude) {
      return `${this.backendUri}?width=${width}&height=${height}&longestSide=${longestSide}` + `&point.latitude=${latitude}&point.longitude=${longitude}`;
    }
    /**
     * Calculate the height of the map based on current width and wanted aspect ratio
     * @param width Width of the map
     * @param aspectRatio Object that contains the width and height proportions
     * @returns Height
     */
    calculateHeight(width, aspectRatio) {
      let multiplier = aspectRatio.width / aspectRatio.height;
      return Math.floor(width / multiplier);
    }
    static {
      this.ɵfac = function MapComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MapComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MapComponent,
        selectors: [["hpo-map"]],
        viewQuery: function MapComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c15, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.map = _t.first);
          }
        },
        hostBindings: function MapComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("resize", function MapComponent_resize_HostBindingHandler() {
              return ctx.onResize();
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          latitude: "latitude",
          longitude: "longitude",
          longestSide: "longestSide",
          height: "height",
          aspectRatio: "aspectRatio"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c8,
        decls: 3,
        vars: 4,
        consts: [["map", ""], [1, "map"]],
        template: function MapComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("height", ctx.height.toString() + "px")("background-image", ctx.coordinatesValid ? "url(" + ctx.mapImage + ")" : "none");
          }
        },
        styles: [".map[_ngcontent-%COMP%]{width:100%;background-color:#eee;background-repeat:no-repeat;background-size:100% auto}"],
        changeDetection: 0
      });
    }
  }
  return MapComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MapModule = /*#__PURE__*/(() => {
  class MapModule {
    static {
      this.ɵfac = function MapModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MapModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MapModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SpinnerModule]
      });
    }
  }
  return MapModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextareaComponent = /*#__PURE__*/(() => {
  class TextareaComponent {
    constructor() {
      this.focus = false;
      this.floatLabel = 'auto';
      this.id = '';
      this.defaultRows = 5;
      this.placeholder = '';
      this.value = '';
      this.disabled = false;
      this.readonly = false;
      this.maxlength = null;
      this.valueChange = new EventEmitter();
    }
    onChange(evt) {
      this.valueChange.emit(evt.target.value);
    }
    ngOnChanges() {
      this.floatLabel = this.readonly ? 'always' : 'auto';
    }
    ngOnInit() {}
    static {
      this.ɵfac = function TextareaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextareaComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TextareaComponent,
        selectors: [["hpo-textarea"]],
        inputs: {
          id: "id",
          defaultRows: "defaultRows",
          placeholder: "placeholder",
          value: "value",
          disabled: "disabled",
          readonly: "readonly",
          maxlength: "maxlength"
        },
        outputs: {
          valueChange: "valueChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 4,
        vars: 12,
        consts: [[3, "ngClass", "floatLabel"], ["matInput", "", 3, "change", "keyup", "focus", "blur", "rows", "id", "disabled", "readonly", "value"], ["align", "end"]],
        template: function TextareaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0);
            i0.ɵɵtemplate(1, TextareaComponent_Conditional_1_Template, 2, 1, "mat-label");
            i0.ɵɵelementStart(2, "textarea", 1);
            i0.ɵɵlistener("change", function TextareaComponent_Template_textarea_change_2_listener($event) {
              return ctx.onChange($event);
            })("keyup", function TextareaComponent_Template_textarea_keyup_2_listener($event) {
              return ctx.onChange($event);
            })("focus", function TextareaComponent_Template_textarea_focus_2_listener() {
              return ctx.focus = true;
            })("blur", function TextareaComponent_Template_textarea_blur_2_listener() {
              return ctx.focus = false;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, TextareaComponent_Conditional_3_Template, 2, 2, "mat-hint", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c13, ctx.readonly))("floatLabel", ctx.floatLabel);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.placeholder ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("rows", ctx.defaultRows)("id", ctx.id)("disabled", ctx.disabled)("readonly", ctx.readonly)("value", ctx.value);
            i0.ɵɵattribute("maxlength", ctx.maxlength);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.focus && ctx.maxlength != null && !ctx.readonly ? 3 : -1);
          }
        },
        dependencies: [i1.NgClass, i2$2.MatInput, i3$1.MatFormField, i3$1.MatLabel, i3$1.MatHint],
        styles: [".mat-mdc-input-element[_ngcontent-%COMP%]:read-only{cursor:default}"],
        changeDetection: 0
      });
    }
  }
  return TextareaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextareaModule = /*#__PURE__*/(() => {
  class TextareaModule {
    static {
      this.ɵfac = function TextareaModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextareaModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TextareaModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatInputModule]
      });
    }
  }
  return TextareaModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * HeadPower component for displaying notifications
 */
let NotificationComponent = /*#__PURE__*/(() => {
  class NotificationComponent {
    constructor(router) {
      this.router = router;
      this.color = 'primary'; // Colors are: primary, accent, warn & none
      this.show = true;
      this.fontSize = '1.6rem';
      this.closeable = false;
      this.closed = new EventEmitter();
      this.displayLink = false;
      this.linkClick$ = new EventEmitter();
    }
    ngOnInit() {}
    closeClick() {
      this.show = false;
    }
    linkClick() {
      this.linkClick$.emit();
      if (this.linkHref) {
        // If link href starts with http or https assume it is external
        if (this.linkHref.startsWith('http')) {
          window.location.href = this.linkHref;
        } else {
          this.router.navigate([this.linkHref]);
        }
      }
    }
    animationDone(event) {
      if (event.toState == 'void') {
        this.closed.emit();
      }
    }
    static {
      this.ɵfac = function NotificationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationComponent)(i0.ɵɵdirectiveInject(i2$3.Router));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NotificationComponent,
        selectors: [["hpo-notification"]],
        inputs: {
          color: "color",
          show: "show",
          width: "width",
          fontSize: "fontSize",
          closeable: "closeable",
          displayLink: "displayLink",
          linkText: "linkText",
          linkHref: "linkHref"
        },
        outputs: {
          closed: "closed",
          linkClick$: "linkClick"
        },
        ngContentSelectors: _c8,
        decls: 1,
        vars: 1,
        consts: [["class", "notification-container", 4, "ngIf"], [1, "notification-container"], [1, "notification-wrapper"], ["class", "close", 3, "click", 4, "ngIf"], [1, "message"], ["class", "link-container", 4, "ngIf"], [1, "close", 3, "click"], [1, "link-container"], ["color", "primary", 3, "click"]],
        template: function NotificationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NotificationComponent_div_0_Template, 7, 10, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.show);
          }
        },
        dependencies: [i1.NgIf, i3$2.MatIcon, ButtonComponent],
        styles: [".notification-container[_ngcontent-%COMP%]{margin:1.6rem}.notification-wrapper[_ngcontent-%COMP%]{width:75%;text-align:center;position:relative;margin:0 auto}@media (max-width: 959.98px){.notification-wrapper[_ngcontent-%COMP%]{width:auto}}.message-container[_ngcontent-%COMP%]{padding:1.6rem;box-shadow:0 1px 8px #00000040;text-align:center}.message-container[_ngcontent-%COMP%] > .close[_ngcontent-%COMP%]{position:absolute;top:0;right:0;margin:1.4rem;line-height:0;outline:none;cursor:pointer}.message[_ngcontent-%COMP%]{word-break:break-all}.link-container[_ngcontent-%COMP%]{margin-top:3.2rem}"],
        data: {
          animation: [trigger('fadeInOut', [state('void', style({
            opacity: 0
          })), state('*', style({
            opacity: 1
          })), transition(':enter', animate('150ms ease-out')), transition(':leave', animate('150ms ease-in'))])]
        }
      });
    }
  }
  return NotificationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotificationModule = /*#__PURE__*/(() => {
  class NotificationModule {
    static {
      this.ɵfac = function NotificationModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NotificationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NotificationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatIconModule, ButtonModule]
      });
    }
  }
  return NotificationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * HeadPower component for displaying HPO icons
 */
let HpoIconComponent = /*#__PURE__*/(() => {
  class HpoIconComponent {
    constructor() {
      this.hostClass = 'hpo-icons';
      this.color = null;
    }
    ngOnInit() {}
    ngOnChanges(changes) {
      if (changes['color']) {
        this.updateColor();
      }
    }
    updateColor() {
      this.hostClass = this.color ? 'hpo-icons color ' + this.color : 'hpo-icons';
    }
    static {
      this.ɵfac = function HpoIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HpoIconComponent,
        selectors: [["hpo-icon"]],
        hostVars: 2,
        hostBindings: function HpoIconComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.hostClass);
          }
        },
        inputs: {
          color: "color"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c8,
        decls: 1,
        vars: 0,
        template: function HpoIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        changeDetection: 0
      });
    }
  }
  return HpoIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HpoIconModule = /*#__PURE__*/(() => {
  class HpoIconModule {
    static {
      this.ɵfac = function HpoIconModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoIconModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: HpoIconModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return HpoIconModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HpoNumberComponent = /*#__PURE__*/(() => {
  class HpoNumberComponent {
    constructor() {
      this.id = '';
      this.placeholder = ' '; // Empty string makes it possible to show asterix when input is required.
      this.required = false;
      this.positiveValueOnly = false;
      this.nonnegativeValueOnly = false;
      this.textAlign = "right";
      this.numberChange = new EventEmitter();
      this.hasError = false;
      this.hasNegativeValueError = false;
    }
    /**
    * Called when component value changes
    * */
    onChange(evt) {
      const value = evt.target.value;
      if (value == null || value.trim() === '') {
        this.hasError = false;
        this.hasNegativeValueError = false;
        if (this.emitNullAsZero) {
          this.number = 0;
          // This updates the DOM view when user has tried to empty zero value
          // (does not trigger onchanges as equals giving same number twice)
          this.value = new String(this.number.toFixed(this.decimals).replace('.', ','));
        } else {
          this.number = null;
        }
        this.numberChange.emit(this.number);
      } else {
        const asString = value.replace(',', '.');
        const asNumber = Number.parseFloat(asString);
        // Check if the value is negative or zero, if we are interested only of positive values
        if ((this.positiveValueOnly === true || this.nonnegativeValueOnly === true) && !isNaN(Number(asString)) && (this.positiveValueOnly ? Number.parseFloat(asNumber.toFixed(this.decimals)) <= 0 : Number.parseFloat(asNumber.toFixed(this.decimals)) < 0)) {
          // This updates the DOM view to match decimal count 
          // but change is not emitted outside component since value is faulty
          this.value = new String(asNumber.toFixed(this.decimals).replace('.', ','));
          this.hasError = false;
          this.hasNegativeValueError = true;
        } else if (!isNaN(Number(asString))) {
          this.hasError = false;
          this.hasNegativeValueError = false;
          this.number = asNumber;
          this.number = Number.parseFloat(this.number.toFixed(this.decimals));
          this.numberChange.emit(this.number);
          // This updates the DOM view even if the user gives the same number twice
          this.value = new String(this.number.toFixed(this.decimals).replace('.', ','));
        } else {
          this.hasNegativeValueError = false;
          this.hasError = true;
        }
      }
    }
    ngOnInit() {}
    ngOnChanges(changes) {
      if (changes.number || changes.decimals) {
        if (this.number == null) {
          this.value = '';
        } else {
          this.hasError = false;
          this.hasNegativeValueError = false;
          // New string is always created to force DOM update (otherwise DOM doesn't show the correctly rounded number)
          // See: https://stackoverflow.com/questions/53427571/ngmodelchange-does-not-update-the-ui-for-specific-input
          this.value = new String(this.number.toFixed(this.decimals).replace('.', ','));
        }
      }
      if (changes.id) {
        // If id was not given, generate random so that it's not empty
        if (this.id === '') {
          this.id = 'number-' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        }
      }
    }
    static {
      this.ɵfac = function HpoNumberComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoNumberComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HpoNumberComponent,
        selectors: [["hpo-number"]],
        inputs: {
          id: "id",
          placeholder: "placeholder",
          number: "number",
          decimals: "decimals",
          emitNullAsZero: "emitNullAsZero",
          readonly: "readonly",
          required: "required",
          positiveValueOnly: "positiveValueOnly",
          nonnegativeValueOnly: "nonnegativeValueOnly",
          textAlign: "textAlign"
        },
        outputs: {
          numberChange: "numberChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 15,
        consts: [[3, "ngClass"], ["matInput", "", "inputmode", "numeric", "autocomplete", "off", "maxlength", "12", "autocomplete", "off", 3, "change", "ngClass", "id", "value", "readonly", "tabindex", "required"], [2, "color", "red", 3, "align"]],
        template: function HpoNumberComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0);
            i0.ɵɵtemplate(1, HpoNumberComponent_Conditional_1_Template, 2, 1, "mat-label");
            i0.ɵɵelementStart(2, "input", 1);
            i0.ɵɵlistener("change", function HpoNumberComponent_Template_input_change_2_listener($event) {
              return ctx.onChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, HpoNumberComponent_Conditional_3_Template, 3, 4, "mat-hint", 2)(4, HpoNumberComponent_Conditional_4_Template, 3, 4, "mat-hint", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c13, ctx.readonly));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.placeholder ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c16, ctx.textAlign !== "left", ctx.textAlign === "left"))("id", ctx.id)("value", ctx.value)("readonly", ctx.readonly)("tabindex", ctx.readonly ? -1 : 0)("required", ctx.required);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasError ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.hasNegativeValueError ? 4 : -1);
          }
        },
        dependencies: [i1.NgClass, i2$2.MatInput, i3$1.MatFormField, i3$1.MatLabel, i3$1.MatHint, i1$1.BlahPipe],
        styles: [".right[_ngcontent-%COMP%]{text-align:right}.left[_ngcontent-%COMP%]{text-align:left}.mat-mdc-input-element[_ngcontent-%COMP%]:read-only{cursor:default}"],
        changeDetection: 0
      });
    }
  }
  return HpoNumberComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DecimalNumberDirective = /*#__PURE__*/(() => {
  class DecimalNumberDirective {
    constructor(el) {
      this.el = el;
      this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'Delete', 'ArrowLeft', 'ArrowRight'];
    }
    onKeyDown(event) {
      // Allow Backspace, tab, end, and home keys
      if (this.specialKeys.indexOf(event.key) !== -1) {
        return;
      }
      const regex = new RegExp('^\\d*\\.?\\,?\\d{0,' + this.numberOfDecimals + '}$', 'g');
      const current = this.el.nativeElement.value;
      const next = current.concat(event.key);
      if (next && !String(next).match(regex)) {
        event.preventDefault();
      }
    }
    static {
      this.ɵfac = function DecimalNumberDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DecimalNumberDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DecimalNumberDirective,
        selectors: [["", "appDecimalNumber", ""]],
        hostBindings: function DecimalNumberDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keydown", function DecimalNumberDirective_keydown_HostBindingHandler($event) {
              return ctx.onKeyDown($event);
            });
          }
        },
        inputs: {
          numberOfDecimals: "numberOfDecimals"
        }
      });
    }
  }
  return DecimalNumberDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HpoNumberModule = /*#__PURE__*/(() => {
  class HpoNumberModule {
    static {
      this.ɵfac = function HpoNumberModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoNumberModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: HpoNumberModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, BlahModule, MatInputModule]
      });
    }
  }
  return HpoNumberModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: This component has a major memory leak due to external addsearch script!
let AddSearchComponent = /*#__PURE__*/(() => {
  class AddSearchComponent {
    constructor(renderer2, _document) {
      this.renderer2 = renderer2;
      this._document = _document;
      // https://www.addsearch.com/support/documentation/setup-settings/search-widgets-settings/
      // Default order of results
      this.defaultSortBy = 'relevance'; // date or relevance
      // Placeholder text to show in the search field
      this.placeholder = 'Add search';
      // Window or a frame where the clicked results link should open. E.g. _blank to open links in a new tab.
      this.linkTarget = '_blank'; // Targets are: _blank, _self, _top,  & _parent
      // Display the publishing date of search results instead of category
      this.displayDate = false;
      // Enable right-to-left UI by setting the value to rtl
      this.direction = 'ltr'; // rtl, ltr
      // CSS class name added to #addsearch-results div. Practical for A/B testing and such
      this.resultsBoxCssClassname = '';
      // Define if the results box opens to the left-hand or right-hand side below the search field.
      // By default, the value is calculated automatically
      this.resultsBoxOpeningDirection = ''; // left, right, center
      this.addSearchScriptSrc = 'https://addsearch.com/js/?key=a7311bc14341503544ed9be203f57872';
      this.addSearchConfigObject = {};
    }
    ngOnInit() {
      this.setConfiguration();
    }
    ngAfterViewInit() {
      this.renderAddSearchScript();
    }
    // Configuration for AddSearch
    setConfiguration() {
      this.addSearchConfigObject = new Object({
        default_sortby: this.checkDefaultSortByValue(this.defaultSortBy),
        placeholder: this.placeholder,
        link_target: this.checkLinkTargetValue(this.linkTarget),
        display_date: this.displayDate,
        direction: this.checkDirectionValue(this.direction),
        results_box_css_classname: this.resultsBoxCssClassname,
        results_box_opening_direction: this.resultsBoxOpeningDirection
      });
      window['addsearch_settings'] = this.addSearchConfigObject;
    }
    // Check is given default sort by parameter valid
    checkDefaultSortByValue(defaultSortyValue) {
      if (['date', 'relevance'].indexOf(defaultSortyValue) < 0) {
        console.log('AddSearch: ' + defaultSortyValue + ' is not valid value for default_sortby property. Options are date or relevance. Using relevance as default value');
        return 'relevance';
      } else {
        return defaultSortyValue;
      }
    }
    // Check is given link target parameter valid
    checkLinkTargetValue(linkTargetValue) {
      if (['_blank', '_self', '_top', '_parent'].indexOf(linkTargetValue) < 0) {
        console.log('AddSearch: ' + linkTargetValue + ' is not valid value for link_target property. Options are _blank, _self, _top, and _parent. Using _blank as default value');
        return '_blank';
      } else {
        return linkTargetValue;
      }
    }
    // Check is given direction parameter valid
    checkDirectionValue(directionValue) {
      if (['ltr', 'rtl'].indexOf(directionValue) < 0) {
        console.log('AddSearch: ' + directionValue + ' is not valid value for direction property. Options are ltr and rtl. Using ltr as default value');
        return 'ltr';
      } else {
        return directionValue;
      }
    }
    // Script injection to bypass Angular inline script preventation
    renderAddSearchScript() {
      const script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.src = this.addSearchScriptSrc;
      script.text = ``;
      this.renderer2.appendChild(this._document.body, script);
    }
    static {
      this.ɵfac = function AddSearchComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddSearchComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddSearchComponent,
        selectors: [["AddSearch"]],
        inputs: {
          defaultSortBy: "defaultSortBy",
          placeholder: "placeholder",
          linkTarget: "linkTarget",
          displayDate: "displayDate",
          direction: "direction",
          resultsBoxCssClassname: "resultsBoxCssClassname",
          resultsBoxOpeningDirection: "resultsBoxOpeningDirection"
        },
        decls: 4,
        vars: 1,
        consts: [["matInput", "", "id", "add-search", 1, "addsearch", 3, "placeholder"], ["matSuffix", ""]],
        template: function AddSearchComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field");
            i0.ɵɵelement(1, "input", 0);
            i0.ɵɵelementStart(2, "mat-icon", 1);
            i0.ɵɵtext(3, "search");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("placeholder", ctx.placeholder);
          }
        },
        dependencies: [i2$2.MatInput, i3$1.MatFormField, i3$1.MatSuffix, i3$2.MatIcon]
      });
    }
  }
  return AddSearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddSearchModule = /*#__PURE__*/(() => {
  class AddSearchModule {
    static {
      this.ɵfac = function AddSearchModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddSearchModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AddSearchModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatInputModule, MatIconModule]
      });
    }
  }
  return AddSearchModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextComponent = /*#__PURE__*/(() => {
  class TextComponent {
    set value(val) {
      if (val !== undefined && this.val !== val) {
        this.val = val;
        this.onChange(val);
        this.onTouch(val);
      }
    }
    get value() {
      return this.val;
    }
    constructor(cdRef) {
      this.cdRef = cdRef;
      this.focus = false;
      this.floatLabel = 'auto';
      this.val = '';
      this.id = '';
      this.placeholder = '';
      this.type = 'text';
      this.disabled = false;
      this.readonly = false;
      this.maxlength = null;
      this.onChange = () => {};
      this.onTouch = () => {};
    }
    ngOnChanges() {
      this.floatLabel = this.readonly ? 'always' : 'auto';
      this.cdRef.markForCheck();
    }
    /**
     * Set value programmatically
     */
    writeValue(value) {
      this.value = value;
      this.cdRef.markForCheck();
    }
    /**
     * WhenUI element value changes, this method gets triggered
     */
    registerOnChange(fn) {
      this.onChange = fn;
      this.cdRef.markForCheck();
    }
    /**
     * When touching the element, this method gets triggered
     */
    registerOnTouched(fn) {
      this.onTouch = fn;
      this.cdRef.markForCheck();
    }
    ngOnInit() {}
    static {
      this.ɵfac = function TextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TextComponent,
        selectors: [["hpo-text"]],
        inputs: {
          id: "id",
          placeholder: "placeholder",
          type: "type",
          disabled: "disabled",
          readonly: "readonly",
          maxlength: "maxlength",
          errorStateMatcher: "errorStateMatcher",
          errorMessage: "errorMessage"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => TextComponent),
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 6,
        vars: 14,
        consts: [[3, "ngClass", "floatLabel"], ["matInput", "", "ngDefaultControl", "", 3, "ngModelChange", "focus", "blur", "ngModel", "id", "type", "disabled", "readonly", "errorStateMatcher"], ["align", "end"]],
        template: function TextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0);
            i0.ɵɵtemplate(1, TextComponent_Conditional_1_Template, 2, 1, "mat-label");
            i0.ɵɵelementStart(2, "input", 1);
            i0.ɵɵtwoWayListener("ngModelChange", function TextComponent_Template_input_ngModelChange_2_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
              return $event;
            });
            i0.ɵɵlistener("focus", function TextComponent_Template_input_focus_2_listener() {
              return ctx.focus = true;
            })("blur", function TextComponent_Template_input_blur_2_listener() {
              return ctx.focus = false;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "mat-error");
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, TextComponent_Conditional_5_Template, 2, 2, "mat-hint", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c13, ctx.readonly))("floatLabel", ctx.floatLabel);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.placeholder ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("id", ctx.id)("type", ctx.type)("disabled", ctx.disabled)("readonly", ctx.readonly)("errorStateMatcher", ctx.errorStateMatcher);
            i0.ɵɵattribute("maxlength", ctx.maxlength);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.errorMessage);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.focus && ctx.maxlength != null && !ctx.readonly ? 5 : -1);
          }
        },
        dependencies: [i1.NgClass, i2$2.MatInput, i3$1.MatFormField, i3$1.MatLabel, i3$1.MatHint, i3$1.MatError, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel],
        styles: [_c17],
        changeDetection: 0
      });
    }
  }
  return TextComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextModule = /*#__PURE__*/(() => {
  class TextModule {
    static {
      this.ɵfac = function TextModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TextModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatInputModule, FormsModule, ReactiveFormsModule]
      });
    }
  }
  return TextModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NoteComponent = /*#__PURE__*/(() => {
  class NoteComponent {
    set value(val) {
      if (val !== undefined && this.val !== val) {
        this.val = val;
        this.onChange(val);
        this.onTouch(val);
      }
    }
    get value() {
      return this.val;
    }
    constructor(cdRef) {
      this.cdRef = cdRef;
      this.focus = false;
      this.floatLabel = 'auto';
      this.val = '';
      this.id = '';
      this.placeholder = '';
      this.type = 'text';
      this.disabled = false;
      this.readonly = false;
      this.maxlength = null;
      this.defaultRows = 5;
      this.onChange = () => {};
      this.onTouch = () => {};
    }
    ngOnChanges() {
      this.floatLabel = this.readonly ? 'always' : 'auto';
      this.cdRef.markForCheck();
    }
    /**
     * Set value programmatically
     */
    writeValue(value) {
      this.value = value;
      const ref = this.cdRef;
      if (!ref['destroyed']) {
        this.cdRef.markForCheck();
      }
    }
    /**
     * WhenUI element value changes, this method gets triggered
     */
    registerOnChange(fn) {
      this.onChange = fn;
      this.cdRef.markForCheck();
    }
    /**
     * When touching the element, this method gets triggered
     */
    registerOnTouched(fn) {
      this.onTouch = fn;
      this.cdRef.markForCheck();
    }
    ngOnInit() {}
    static {
      this.ɵfac = function NoteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NoteComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NoteComponent,
        selectors: [["hpo-note"]],
        inputs: {
          id: "id",
          placeholder: "placeholder",
          type: "type",
          disabled: "disabled",
          readonly: "readonly",
          maxlength: "maxlength",
          defaultRows: "defaultRows",
          errorStateMatcher: "errorStateMatcher",
          errorMessage: "errorMessage"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => NoteComponent),
          multi: true
        }]), i0.ɵɵNgOnChangesFeature],
        decls: 7,
        vars: 15,
        consts: [[1, "hpo-textarea-fullwidth", 3, "ngClass", "floatLabel"], ["matInput", "", "ngDefaultControl", "", 3, "ngModelChange", "focus", "blur", "ngModel", "id", "type", "disabled", "readonly", "errorStateMatcher", "rows"], ["align", "end", 4, "ngIf"], ["align", "end"]],
        template: function NoteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-form-field", 0);
            i0.ɵɵtemplate(1, NoteComponent_Conditional_1_Template, 2, 1, "mat-label");
            i0.ɵɵelementStart(2, "textarea", 1);
            i0.ɵɵtwoWayListener("ngModelChange", function NoteComponent_Template_textarea_ngModelChange_2_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
              return $event;
            });
            i0.ɵɵlistener("focus", function NoteComponent_Template_textarea_focus_2_listener() {
              return ctx.focus = true;
            })("blur", function NoteComponent_Template_textarea_blur_2_listener() {
              return ctx.focus = false;
            });
            i0.ɵɵtext(3, "    ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "mat-error");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, NoteComponent_mat_hint_6_Template, 2, 2, "mat-hint", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c13, ctx.readonly))("floatLabel", ctx.floatLabel);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.placeholder ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("id", ctx.id)("type", ctx.type)("disabled", ctx.disabled)("readonly", ctx.readonly)("errorStateMatcher", ctx.errorStateMatcher)("rows", ctx.defaultRows);
            i0.ɵɵattribute("maxlength", ctx.maxlength);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.errorMessage);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.focus && ctx.maxlength !== null && !ctx.readonly);
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2$2.MatInput, i3$1.MatFormField, i3$1.MatLabel, i3$1.MatHint, i3$1.MatError, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel],
        styles: [".hpo-textarea-fullwidth[_ngcontent-%COMP%]{min-width:50px}.mat-mdc-input-element[_ngcontent-%COMP%]:read-only{cursor:default}.mat-mdc-form-field.read-only[_ngcontent-%COMP%]     .mdc-line-ripple{display:none}"],
        changeDetection: 0
      });
    }
  }
  return NoteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NoteModule = /*#__PURE__*/(() => {
  class NoteModule {
    static {
      this.ɵfac = function NoteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NoteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NoteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatInputModule, FormsModule, ReactiveFormsModule]
      });
    }
  }
  return NoteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlaceholderComponent = /*#__PURE__*/(() => {
  class PlaceholderComponent {
    constructor() {
      // Width can be any CSS accepted value
      this.width = '100%';
      this.type = 'input';
      // How many rows input is expected to be
      this.rows = 1;
    }
    ngOnInit() {}
    static {
      this.ɵfac = function PlaceholderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlaceholderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PlaceholderComponent,
        selectors: [["hpo-placeholder"]],
        inputs: {
          width: "width",
          type: "type",
          rows: "rows"
        },
        decls: 5,
        vars: 6,
        consts: [[1, "placeholder", 3, "ngStyle"], [1, "loading"], [4, "ngIf"], [1, "title"], [1, "input", 3, "ngStyle"], [1, "button"], [1, "row"]],
        template: function PlaceholderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, PlaceholderComponent_ng_container_2_Template, 3, 3, "ng-container", 2)(3, PlaceholderComponent_ng_container_3_Template, 3, 0, "ng-container", 2)(4, PlaceholderComponent_ng_container_4_Template, 3, 0, "ng-container", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c18, ctx.width));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.type === "input");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "button");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "row");
          }
        },
        dependencies: [i1.NgIf, i1.NgStyle],
        styles: [".placeholder[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]{display:grid;grid-template-columns:auto;margin-bottom:28px;position:relative;overflow:hidden}.placeholder[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]:after{display:block;content:\"\";position:absolute;width:100%;height:100%;transform:translate(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.67),transparent);animation:_ngcontent-%COMP%_loading 1.5s infinite}@keyframes _ngcontent-%COMP%_loading{to{transform:translate(100%)}}.placeholder[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{grid-row:1;border-radius:3px;background-color:#eee;height:12px;width:120px;margin-bottom:8px;animation-name:wave;animation-duration:2s;animation-iteration-count:infinite}.placeholder[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]   .input[_ngcontent-%COMP%]{width:100%;grid-row:2;border-radius:3px;background-color:#eee}.placeholder[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]   .button[_ngcontent-%COMP%]{height:36px;border-radius:3px;background-color:#eee}.placeholder[_ngcontent-%COMP%]   .loading[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{height:36px;width:100%;border-radius:3px;background-color:#eee}"],
        changeDetection: 0
      });
    }
  }
  return PlaceholderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PlaceholderModule = /*#__PURE__*/(() => {
  class PlaceholderModule {
    static {
      this.ɵfac = function PlaceholderModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PlaceholderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PlaceholderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return PlaceholderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentBlockComponent = /*#__PURE__*/(() => {
  class ContentBlockComponent {
    constructor() {
      this.title = '';
      this.anchor = '';
      this.icon = '';
      this.iconTooltip = '';
      this.hidden = false;
    }
    static {
      this.ɵfac = function ContentBlockComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContentBlockComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentBlockComponent,
        selectors: [["hpo-content-block"]],
        viewQuery: function ContentBlockComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c20, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.blockRef = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function ContentBlockComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("hidden", ctx.hidden);
          }
        },
        inputs: {
          title: "title",
          id: "id",
          anchor: "anchor",
          icon: "icon",
          iconTooltip: "iconTooltip",
          hidden: "hidden"
        },
        ngContentSelectors: _c8,
        decls: 4,
        vars: 1,
        consts: [["block", ""], [3, "name"]],
        template: function ContentBlockComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", null, 0);
            i0.ɵɵelement(2, "a", 1);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("name", ctx.anchor);
          }
        },
        styles: [".hidden[_nghost-%COMP%]{display:none}"],
        changeDetection: 0
      });
    }
  }
  return ContentBlockComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentLayoutService = /*#__PURE__*/(() => {
  class ContentLayoutService {
    constructor() {
      this.moveToSection$ = new Subject();
      // <fullRefresh>
      this.refresh$ = new Subject();
      this.moveToSectionPending = false;
      this.calculateOffsetsPending = false;
      this.refreshPending = false;
    }
    /**
     * Moves to a point on the page by section title.
     *
     * @param title Title of the section
     * @param behavior Scroll behavior. Defaults to "smooth".
     */
    moveToSection(title, behavior = 'smooth') {
      // Throttle section scrolling so only one event can happen at a time
      if (!this.moveToSectionPending) {
        this.moveToSectionPending = true;
        // Async request
        setTimeout(() => {
          this.moveToSection$.next({
            title,
            behavior
          });
          this.moveToSectionPending = false;
        });
      }
    }
    /**
     * Calculates navigation offsets.
     *
     * Should be called after UI change that drastically changes the height of a section.
     */
    calculateOffsets() {
      // Throttle calculation so only one event can happen at a time
      if (!this.calculateOffsetsPending) {
        this.calculateOffsetsPending = true;
        // Async request
        setTimeout(() => {
          this.refresh$.next(false);
          this.calculateOffsetsPending = false;
        });
      }
    }
    /**
     * Refreshes the content-layout.
     *
     * Should be called after changing section title. F.ex. after locale change.
     */
    refresh() {
      // Throttle refresh so only one event can happen at a time
      if (!this.refreshPending) {
        this.refreshPending = true;
        // Async request
        setTimeout(() => {
          this.refresh$.next(true);
          this.refreshPending = false;
        });
      }
    }
    static {
      this.ɵfac = function ContentLayoutService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContentLayoutService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ContentLayoutService,
        factory: ContentLayoutService.ɵfac
      });
    }
  }
  return ContentLayoutService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentLayoutComponent = /*#__PURE__*/(() => {
  class ContentLayoutComponent {
    get visibleContentBlocks() {
      return this.contentBlocks.filter(o => !o.hidden);
    }
    constructor(contentLayoutService, cdRef, route, router, location) {
      this.contentLayoutService = contentLayoutService;
      this.cdRef = cdRef;
      this.route = route;
      this.router = router;
      this.location = location;
      // Optional mobile setting for forcing mobile layout
      this.mobile = false;
      this.fullscreen = false;
      this.sideDrawerVisible = false;
      this.sideDrawerVisibleChange = new EventEmitter();
      this.sideDrawerOffsetY = 0;
      // Use anchors enables scrolling by anchors
      this.useAnchors = false;
      this.scrollTo = '';
      this.navigation = true;
      // Tells the parent component when the page is scrolling, and to which part of the page
      this.scrolling = new EventEmitter();
      this.contentBlocks = new QueryList();
      this.topOffsets = [];
      this.blockProperties = [];
      this.pageYOffset = 0;
      this.toolbarInitialized = false;
      this.lastOffset = null;
      this.sideDrawerTop = 0;
      this.toolbarHeight = 0;
      this.toolbarShadow = false;
      this.gridWidth = 0;
      this.highlightIndex = 0;
      this.isComponentMounted = false;
      this.loadingPhase = true;
      this.destroy$ = new Subject();
    }
    ngOnChanges(changes) {
      if (changes.toolbarTemplate && changes.toolbarTemplate.currentValue && !this.toolbarInitialized) {
        this.toolbarInitialized = true;
        timer(0, 500).pipe(takeUntil(this.destroy$)).subscribe(() => {
          if (this.toolbar && this.toolbar.nativeElement) {
            if (!this.toolbarShadow && window.pageYOffset > 0) {
              this.toolbarShadow = true;
            } else if (this.toolbarShadow && window.pageYOffset === 0) {
              this.toolbarShadow = false;
            }
            if (this.toolbarHeight !== this.toolbar.nativeElement.offsetHeight) {
              this.toolbarHeight = this.toolbar.nativeElement.offsetHeight;
              this.pageYOffset = this.toolbar.nativeElement.offsetHeight;
              this.calculateOffsets();
            }
            if (this.gridWidth !== this.grid.nativeElement.offsetWidth) {
              this.gridWidth = this.grid.nativeElement.offsetWidth;
            }
          } else {
            this.toolbarShadow = false;
            this.toolbarHeight = 0;
            this.pageYOffset = 2;
            this.calculateOffsets();
          }
          this.sideDrawerTop = this.sideDrawerOffsetY + this.toolbarHeight;
          this.cdRef.markForCheck();
        });
      }
      if (changes.scrollTo && changes.scrollTo.currentValue) {
        if (this.isComponentMounted) {
          this.moveToSectionByTitle(changes.scrollTo.currentValue);
        } else {
          // If the child components do not exist at the moment of scroll call,
          // wait until they are available.
          let waitForChildComponents = timer(100, 100).pipe(takeUntil(this.destroy$)).subscribe(() => {
            if (this.isComponentMounted) {
              waitForChildComponents.unsubscribe();
              this.moveToSectionByTitle(changes.scrollTo.currentValue);
            }
          });
        }
      }
    }
    ngOnInit() {
      // Set initial page y-axis offset pixel count
      this.pageYOffset = 2;
      this.sideDrawerTop = this.sideDrawerOffsetY + this.toolbarHeight;
      this.contentLayoutService.moveToSection$.pipe(takeUntil(this.destroy$)).subscribe(result => this.moveToSectionByTitle(result.title, result.behavior));
      this.contentLayoutService.refresh$.pipe(takeUntil(this.destroy$)).subscribe(fullRefresh => {
        if (fullRefresh) {
          this.refresh();
        } else {
          this.calculateOffsets();
        }
      });
      // Loading phase lasts for 10 seconds after Content layout has been initialized
      setTimeout(() => {
        this.loadingPhase = false;
      }, 10000);
    }
    ngAfterViewInit() {
      if (this.navigation) {
        timer(0, 250).pipe(takeUntil(this.destroy$)).subscribe(() => {
          const offset = window.pageYOffset;
          let changed = false;
          if (this.visibleContentBlocks.length !== this.blockProperties.length) {
            this.setContentBlockProperties();
            changed = true;
          }
          // Update navigation locations if user has scrolled, we are in loading phase
          // or navigation menu has changed.
          if (offset !== this.lastOffset || this.loadingPhase || changed) {
            this.lastOffset = offset;
            this.visibleContentBlocks.forEach((block, i) => {
              this.topOffsets[i] = block.blockRef.nativeElement.offsetTop - this.pageYOffset;
            });
            for (let i = 0; i < this.topOffsets.length; i++) {
              // if last
              if (!this.topOffsets[i + 1]) {
                this.highlightIndex = i;
                break;
              }
              // if first
              if (this.topOffsets[0] > offset + 50) {
                this.highlightIndex = 0;
                break;
              }
              if (this.topOffsets[i] <= offset + 50 && this.topOffsets[i + 1] > offset + 50) {
                this.highlightIndex = i;
                break;
              }
            }
            changed = true;
          }
          if (changed) {
            this.cdRef.markForCheck();
          }
        });
      }
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
     * Closes the sidenav.
     */
    closeSidenav() {
      this.sideDrawerVisibleChange.emit(false);
    }
    /**
     * Moves to a point on the page by section.
     *
     * @param index Index of the section
     * @param id Id of the anchor. Optional.
     */
    moveToSection(index, id) {
      if (typeof this.topOffsets[index] === 'undefined') {
        return;
      }
      if (this.useAnchors) {
        const url = this.router.createUrlTree([], {
          relativeTo: this.route
        }).toString();
        this.location.go(`${url}#${id}`);
      }
      window.scrollTo({
        behavior: 'smooth',
        top: this.topOffsets[index],
        left: 0
      });
      this.scrollNotifier(this.blockProperties[index]?.id);
    }
    /**
     * Moves to a point on the page by section title.
     *
     * @param title Title of the section
     * @param behavior Scroll behavior. Defaults to "smooth".
     */
    moveToSectionByTitle(title, behavior = 'smooth') {
      const block = this.visibleContentBlocks.find(block => block.title === title);
      if (!block) {
        return;
      }
      const offset = block.blockRef.nativeElement.offsetTop - this.pageYOffset;
      if (behavior === 'smooth') {
        window.scrollTo({
          behavior: 'smooth',
          top: offset,
          left: 0
        });
      } else {
        window.scrollTo({
          top: offset,
          left: 0
        });
      }
      this.scrollNotifier(block.id);
    }
    /**
     * Calculates navigation offsets.
     *
     * Should be called after UI change that drastically changes the height of a section.
     */
    calculateOffsets() {
      // Reset last offset so the navigation offsets will be updated in the next tick
      this.lastOffset = null;
    }
    /**
     * Refreshes the content-layout.
     *
     * Should be called after changing section titles. F.ex. after locale change.
     */
    refresh() {
      this.setContentBlockProperties();
      this.calculateOffsets();
    }
    /**
     * Sets content block properties for the page.
     */
    setContentBlockProperties() {
      let tempBlockProperties = [];
      let tempTopOffsets = [];
      this.visibleContentBlocks.forEach(block => {
        tempTopOffsets.push(0);
        tempBlockProperties.push({
          title: block.title,
          id: block.id || block.title.toLowerCase().replace(/ /g, '-'),
          anchor: block.anchor,
          icon: block.icon,
          iconTooltip: block.iconTooltip
        });
      });
      this.blockProperties = tempBlockProperties;
      this.topOffsets = tempTopOffsets;
      this.isComponentMounted = true;
      this.cdRef.markForCheck();
    }
    /**
     * Handles scrolling event updates.
     */
    scrollNotifier(target) {
      this.scrolling.emit({
        scrolling: true,
        section: target
      });
      let offset = window.pageYOffset;
      let scrolling = timer(100, 100).pipe(take(20)) // Take first 20 ticks (~2 seconds) then timeout
      .pipe(takeUntil(this.destroy$)).subscribe(() => {
        if (offset !== window.pageYOffset) {
          offset = window.pageYOffset;
        } else {
          scrolling.unsubscribe();
          this.scrolling.emit({
            scrolling: false,
            section: target
          });
        }
      });
    }
    static {
      this.ɵfac = function ContentLayoutComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContentLayoutComponent)(i0.ɵɵdirectiveInject(ContentLayoutService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$3.ActivatedRoute), i0.ɵɵdirectiveInject(i2$3.Router), i0.ɵɵdirectiveInject(i1.Location));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContentLayoutComponent,
        selectors: [["hpo-content-layout"]],
        contentQueries: function ContentLayoutComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, ContentBlockComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentBlocks = _t);
          }
        },
        viewQuery: function ContentLayoutComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c21, 5);
            i0.ɵɵviewQuery(_c22, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.grid = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.toolbar = _t.first);
          }
        },
        inputs: {
          mobile: "mobile",
          fullscreen: "fullscreen",
          sideDrawerVisible: "sideDrawerVisible",
          sideDrawerOffsetY: "sideDrawerOffsetY",
          useAnchors: "useAnchors",
          scrollTo: "scrollTo",
          toolbarTemplate: "toolbarTemplate",
          aboveNavigationTemplate: "aboveNavigationTemplate",
          belowNavigationTemplate: "belowNavigationTemplate",
          sideDrawerTemplate: "sideDrawerTemplate",
          sideDrawerStickyTemplate: "sideDrawerStickyTemplate",
          navigation: "navigation"
        },
        outputs: {
          sideDrawerVisibleChange: "sideDrawerVisibleChange",
          scrolling: "scrolling"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c8,
        decls: 17,
        vars: 26,
        consts: [["grid", ""], ["toolbar", ""], [3, "hasBackdrop"], ["mode", "over", "position", "end", "disableClose", "", 3, "opened", "ngClass"], [2, "padding", "0.5rem", "padding-top", "0"], [1, "contentLayoutSidenavStickyContainer"], [1, "contentLayoutSidenavStickyContent"], ["id", "contentLayoutCloseSidenavButton", "mat-icon-button", "", 3, "click"], [4, "ngTemplateOutlet"], [1, "page-grid", 3, "ngStyle", "ngClass"], ["class", "toolbar no-print", 3, "ngClass", "ngStyle", 4, "ngIf"], [1, "content", 3, "ngClass"], ["class", "navigation no-print", 3, "ngClass", 4, "ngIf"], [1, "toolbar", "no-print", 3, "ngClass", "ngStyle"], [1, "navigation", "no-print", 3, "ngClass"], [1, "hover", 3, "ngStyle"], ["class", "expansion", 4, "ngIf"], [1, "links"], [3, "ngClass", "id", "click", 4, "ngFor", "ngForOf"], [1, "expansion"], [3, "click", "ngClass", "id"], ["class", "icon", "color", "primary-500", 3, "matTooltip", 4, "ngIf"], ["class", "icon", "color", "primary-500", 4, "ngIf"], ["color", "primary-500", 1, "icon", 3, "matTooltip"], ["color", "primary-500", 1, "icon"]],
        template: function ContentLayoutComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "mat-drawer-container", 2)(1, "mat-drawer", 3)(2, "div", 4)(3, "div", 5)(4, "div", 6)(5, "button", 7);
            i0.ɵɵlistener("click", function ContentLayoutComponent_Template_button_click_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closeSidenav());
            });
            i0.ɵɵelementStart(6, "mat-icon");
            i0.ɵɵtext(7, "close");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, ContentLayoutComponent_ng_container_8_Template, 1, 0, "ng-container", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, ContentLayoutComponent_ng_container_9_Template, 1, 0, "ng-container", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(10, "mat-drawer-content")(11, "div", 9, 0);
            i0.ɵɵtemplate(13, ContentLayoutComponent_div_13_Template, 3, 7, "div", 10);
            i0.ɵɵelementStart(14, "div", 11);
            i0.ɵɵprojection(15);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, ContentLayoutComponent_div_16_Template, 6, 10, "div", 12);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("hasBackdrop", false);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("top", ctx.sideDrawerTop, "px");
            i0.ɵɵproperty("opened", ctx.sideDrawerVisible)("ngClass", i0.ɵɵpureFunction2(12, _c23, !ctx.mobile, ctx.mobile));
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.sideDrawerStickyTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.sideDrawerTemplate);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(15, _c24, ctx.toolbarHeight + "px auto"))("ngClass", i0.ɵɵpureFunction5(17, _c25, !ctx.fullscreen && !ctx.mobile, ctx.fullscreen && !ctx.mobile, ctx.mobile, ctx.navigation, !ctx.navigation));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.toolbarTemplate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(23, _c11, !ctx.mobile, ctx.mobile));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.mobile && ctx.navigation);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i2.MatIconButton, i3$2.MatIcon, i6.MatDrawer, i6.MatDrawerContainer, i6.MatDrawerContent, i7.MatTooltip],
        styles: ["@media print{.no-print[_ngcontent-%COMP%]{display:none!important}.navigation[_ngcontent-%COMP%]{grid-template-columns:0 auto 0!important}.mobile.navigation[_ngcontent-%COMP%]{grid-template-columns:auto!important}}.mat-sidenav[_ngcontent-%COMP%]{position:fixed}.mat-sidenav-desktop[_ngcontent-%COMP%]{width:480px}.contentLayoutSidenavStickyContainer[_ngcontent-%COMP%]{position:sticky;top:0;background:#fff;z-index:999}.contentLayoutSidenavStickyContent[_ngcontent-%COMP%]{padding-top:.5rem;padding-bottom:.5rem}.mat-sidenav-handheld[_ngcontent-%COMP%]{width:calc(100vw - 5rem);box-shadow:0 0 8px -1px #0000004d!important}.page-grid[_ngcontent-%COMP%]{display:grid;grid-gap:1.6rem;margin-bottom:.8rem}@media screen and (max-width: 1585px){.page-grid.condensed.no-navigation[_ngcontent-%COMP%]{grid-template-columns:0 auto 0}.page-grid.condensed.navigation[_ngcontent-%COMP%]{grid-template-columns:auto minmax(300px,960px) 320px auto}}@media screen and (min-width: 1586px){.page-grid.condensed.no-navigation[_ngcontent-%COMP%]{grid-template-columns:auto 960px auto}.page-grid.condensed.navigation[_ngcontent-%COMP%]{grid-template-columns:auto 960px 320px auto}}.page-grid.fullscreen[_ngcontent-%COMP%]{width:100%}.page-grid.fullscreen.no-navigation[_ngcontent-%COMP%]{grid-template-columns:0 auto 0}.page-grid.fullscreen.navigation[_ngcontent-%COMP%]{grid-template-columns:0 minmax(300px,auto) 320px 0}.page-grid[_ngcontent-%COMP%]   .toolbar[_ngcontent-%COMP%]{background-color:#f5f5f5;border-bottom:1px solid #DDD;position:fixed;z-index:1050;grid-column:1/5;grid-row:1;transition:box-shadow .2s}.page-grid[_ngcontent-%COMP%]   .toolbar[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{padding:0rem 1.6rem}.page-grid[_ngcontent-%COMP%]   .toolbar.shadow[_ngcontent-%COMP%]{box-shadow:0 1px 4px #00000040}.page-grid.mobile[_ngcontent-%COMP%]{grid-template-columns:minmax(300px,auto)}.page-grid[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{grid-row:2}.page-grid[_ngcontent-%COMP%]   .content.desktop[_ngcontent-%COMP%]{grid-column:2}.page-grid[_ngcontent-%COMP%]   .content.mobile[_ngcontent-%COMP%]{grid-column:1}.page-grid[_ngcontent-%COMP%]   .navigation.desktop[_ngcontent-%COMP%]{grid-column:3;grid-row:2}.page-grid[_ngcontent-%COMP%]   .navigation.mobile[_ngcontent-%COMP%]{grid-column:1;grid-row:3}.page-grid[_ngcontent-%COMP%]   .navigation[_ngcontent-%COMP%]   .hover[_ngcontent-%COMP%]{z-index:2;position:fixed;width:320px;max-height:65vh;overflow-y:auto}.page-grid[_ngcontent-%COMP%]   .navigation[_ngcontent-%COMP%]   .hover[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]{font-size:1.6rem;text-indent:-1.6rem;line-height:1.4;list-style:none;color:var(--color-primary-500);border-left:1px solid #DDD;margin-left:1.1rem;padding:0}.page-grid[_ngcontent-%COMP%]   .navigation[_ngcontent-%COMP%]   .hover[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{cursor:pointer;margin:0 0 .6rem 3rem}.page-grid[_ngcontent-%COMP%]   .navigation[_ngcontent-%COMP%]   .hover[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   li.selected[_ngcontent-%COMP%]{color:var(--color-primary-700);padding:0 0 0 2.9rem;border-left:.3rem solid var(--color-accent-A200);margin-left:-.2rem}.page-grid[_ngcontent-%COMP%]   .navigation[_ngcontent-%COMP%]   .hover[_ngcontent-%COMP%]   .expansion[_ngcontent-%COMP%]{padding:0 2.6rem}.page-grid[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{text-align:right}"],
        changeDetection: 0
      });
    }
  }
  return ContentLayoutComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContentLayoutModule = /*#__PURE__*/(() => {
  class ContentLayoutModule {
    static {
      this.ɵfac = function ContentLayoutModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContentLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ContentLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatIconModule, MatToolbarModule, MatSidenavModule, MatTooltipModule, RouterModule]
      });
    }
  }
  return ContentLayoutModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextTruncatePipe = /*#__PURE__*/(() => {
  class TextTruncatePipe {
    /**
     * Class which is a pipe for truncate texts to specified lengths.
     * For example 'foo bar' | 6 => 'foo...'
     */
    transform(value, maxLength) {
      /**
       * The Pipe transformation.
       * Truncates the given text to specified length. Concatenates '...' to values end if needs to truncate it.
       * For example:
       * 'foo bar' | 6 => 'foo...'
       * 'foo bar' | 7 => 'foo bar'
       */
      if (typeof value !== 'string' || !maxLength) {
        throw new Error('Parameter maxLength or value was null or undefined this is invalid for TextTruncatePipe');
      }
      if (maxLength < 3) {
        throw new Error('Parameter maxLength was set less than 3 which is invalid');
      }
      return value.length <= maxLength ? value : value.substring(0, maxLength - 3) + '...';
    }
    static {
      this.ɵfac = function TextTruncatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextTruncatePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "textTruncate",
        type: TextTruncatePipe,
        pure: true
      });
    }
  }
  return TextTruncatePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextTruncatePipeModule = /*#__PURE__*/(() => {
  class TextTruncatePipeModule {
    static {
      this.ɵfac = function TextTruncatePipeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TextTruncatePipeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TextTruncatePipeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return TextTruncatePipeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TimeAgoPipe = /*#__PURE__*/(() => {
  class TimeAgoPipe {
    transform(value) {
      const valueDate = new Date(value);
      const seconds = Math.round(Math.abs((Date.now() - valueDate.getTime()) / 1000));
      const minutes = Math.round(Math.abs(seconds / 60));
      const hours = Math.round(Math.abs(minutes / 60));
      const days = Math.round(Math.abs(hours / 24));
      const months = Math.round(Math.abs(days / 30.416));
      if (isNaN(seconds)) {
        return '';
      } else if (seconds <= 45) {
        return 'components.timeAgo.fewSeconds';
      } else if (seconds <= 90) {
        return 'components.timeAgo.minute';
      } else if (minutes <= 45) {
        return {
          key: 'components.timeAgo.minutes',
          params: [minutes]
        };
      } else if (minutes <= 90) {
        return 'components.timeAgo.hour';
      } else if (hours <= 22) {
        return {
          key: 'components.timeAgo.hours',
          params: [hours]
        };
      } else if (hours <= 36) {
        return 'components.timeAgo.day';
      } else if (days <= 25) {
        return {
          key: 'components.timeAgo.days',
          params: [days]
        };
      } else if (days <= 45) {
        return 'components.timeAgo.month';
      } else if (days <= 345) {
        return {
          key: 'components.timeAgo.months',
          params: [months]
        };
      } else if (days <= 545) {
        return 'components.timeAgo.year';
      }
      const years = Math.round(Math.abs(days / 365));
      // (days > 545)
      return {
        key: 'components.timeAgo.years',
        params: [years]
      };
    }
    static {
      this.ɵfac = function TimeAgoPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TimeAgoPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "timeAgo",
        type: TimeAgoPipe,
        pure: true
      });
    }
  }
  return TimeAgoPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TimeAgoPipeModule = /*#__PURE__*/(() => {
  class TimeAgoPipeModule {
    static {
      this.ɵfac = function TimeAgoPipeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TimeAgoPipeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TimeAgoPipeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return TimeAgoPipeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Day.js pipe transformer.
 *
 * Basic usage:
 * - {{ '2018-01-01T12:30:20Z+02:00' | dayjs:'l LTS' }}
 *
 * Custom locale:
 * - {{ '2018-01-01T12:30:20Z+02:00' | dayjs:'l LTS':'sv' }}
 *
 * Custom date parse format:
 * - {{ '01.01.2018' | dayjs:'l LTS':null:'DD.MM.YYYY' }}
 */
let DayjsPipe = /*#__PURE__*/(() => {
  class DayjsPipe {
    transform(value, format, locale, parseFormat) {
      return dayjs(value, parseFormat, locale).format(format);
    }
    static {
      this.ɵfac = function DayjsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DayjsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "dayjs",
        type: DayjsPipe,
        pure: true
      });
    }
  }
  return DayjsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DayjsPipeModule = /*#__PURE__*/(() => {
  class DayjsPipeModule {
    static {
      this.ɵfac = function DayjsPipeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DayjsPipeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DayjsPipeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return DayjsPipeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FullScreenDialogComponent = /*#__PURE__*/(() => {
  class FullScreenDialogComponent {
    constructor(dialogRef, dialogData) {
      this.dialogRef = dialogRef;
      this.dialogData = dialogData;
    }
    ngOnInit() {
      this.contentPortal = this.dialogData._contentPortal;
      delete this.dialogData._contentPortal; // Delete reference from dialogData so it wont be passed to final dialog
      // Action clicked subject
      this.action$ = new Subject();
      this.dialogData.actionClicked = this.action$.asObservable();
      // Other properties
      this.rawLabels = !!this.dialogData.rawLabels;
      this.dialogTitle = this.dialogData.dialogTitle;
      this.actionLabel = this.dialogData.actionLabel;
    }
    ngOnDestroy() {
      this.action$.complete();
    }
    closeDialog() {
      this.dialogRef.close();
    }
    actionClicked() {
      this.action$.next();
    }
    static {
      this.ɵfac = function FullScreenDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FullScreenDialogComponent)(i0.ɵɵdirectiveInject(i1$2.MatDialogRef), i0.ɵɵdirectiveInject(MAT_DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FullScreenDialogComponent,
        selectors: [["hpo-full-screen-dialog"]],
        decls: 17,
        vars: 7,
        consts: [["closeButton", ""], [1, "toolbar"], [1, "flex-container"], [1, "toolbar-close"], ["type", "button", "tabindex", "-1", 1, "close-button", 3, "click"], ["matRipple", "", 1, "close-button-ripple", 3, "matRippleTrigger", "matRippleCentered"], [1, "sr-only"], [1, "toolbar-title"], [1, "toolbar-action"], [1, "content-container"], [1, "desktop", "handset"], [3, "cdkPortalOutlet"], [3, "click", "tabbable"]],
        template: function FullScreenDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "div", 3)(3, "button", 4, 0);
            i0.ɵɵlistener("click", function FullScreenDialogComponent_Template_button_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.closeDialog());
            });
            i0.ɵɵelement(5, "div", 5);
            i0.ɵɵelementStart(6, "span", 6);
            i0.ɵɵtext(7, "Close");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "mat-icon");
            i0.ɵɵtext(9, "close");
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "blah");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, FullScreenDialogComponent_Conditional_13_Template, 4, 4, "div", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "div", 9)(15, "div", 10);
            i0.ɵɵtemplate(16, FullScreenDialogComponent_ng_template_16_Template, 0, 0, "ng-template", 11);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const closeButton_r4 = i0.ɵɵreference(4);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("matRippleTrigger", closeButton_r4)("matRippleCentered", true);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", ctx.rawLabels ? ctx.dialogTitle : i0.ɵɵpipeBind1(12, 5, ctx.dialogTitle), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.actionLabel ? 13 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("cdkPortalOutlet", ctx.contentPortal);
          }
        },
        dependencies: [i2$1.MatRipple, i3$2.MatIcon, ButtonComponent, i5$2.CdkPortalOutlet, i1$1.BlahPipe],
        styles: ["[_nghost-%COMP%]     .mat-mdc-dialog-content{max-height:unset}.toolbar[_ngcontent-%COMP%]{position:fixed;z-index:2;height:64px;top:0;left:0;width:100%;line-height:1;box-shadow:0 1px 8px #00000040}.flex-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;align-items:center}.toolbar-close[_ngcontent-%COMP%]{order:1;padding:1rem}.close-button[_ngcontent-%COMP%]{padding:1rem;background:none;border:none;position:relative;line-height:0;outline:none;cursor:pointer}.close-button-ripple[_ngcontent-%COMP%]{top:calc(50% - 25px);left:calc(50% - 25px);width:50px;height:50px;position:absolute;pointer-events:none;border-radius:50%}.toolbar-title[_ngcontent-%COMP%]{order:2;font-size:2rem;padding:2.2rem 0;flex-grow:2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.toolbar-action[_ngcontent-%COMP%]{order:3;padding:0 1rem}.content-container[_ngcontent-%COMP%]{padding-top:64px}"],
        changeDetection: 0
      });
    }
  }
  return FullScreenDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FullScreenDialogService = /*#__PURE__*/(() => {
  class FullScreenDialogService {
    constructor(matDialog) {
      this.matDialog = matDialog;
    }
    open(component, config) {
      let dialogConfig = Object.assign({}, config, {
        width: '100vw',
        maxWidth: '100vw',
        height: '100vh'
      });
      dialogConfig.data = Object.assign({}, dialogConfig.data, {
        _contentPortal: new ComponentPortal(component)
      });
      return this.matDialog.open(FullScreenDialogComponent, dialogConfig);
    }
    static {
      this.ɵfac = function FullScreenDialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FullScreenDialogService)(i0.ɵɵinject(i1$2.MatDialog));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FullScreenDialogService,
        factory: FullScreenDialogService.ɵfac
      });
    }
  }
  return FullScreenDialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FullScreenDialogModule = /*#__PURE__*/(() => {
  class FullScreenDialogModule {
    static {
      this.ɵfac = function FullScreenDialogModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FullScreenDialogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FullScreenDialogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [FullScreenDialogService],
        imports: [CommonModule, BlahModule, MatDialogModule, MatRippleModule, MatIconModule, ButtonModule, PortalModule]
      });
    }
  }
  return FullScreenDialogModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class FloatingActionButtonItem {
  constructor(id, title, icon, action, outOfContext, order, colorOptions, secondaryAction // separated FAB (single action)
  ) {
    this.id = id;
    this.title = title;
    this.icon = icon;
    this.action = action;
    this.outOfContext = outOfContext;
    this.order = order;
    this.colorOptions = colorOptions;
    this.secondaryAction = secondaryAction;
  }
}
let FloatingActionButtonService = /*#__PURE__*/(() => {
  class FloatingActionButtonService {
    constructor() {
      this.isVisible$ = new BehaviorSubject(true);
      this.isDisabled$ = new BehaviorSubject(false);
      this.buttons$ = new BehaviorSubject([]);
      this.reset$ = new Subject();
      // Building array for buttons
      this.buttons = [];
      this.announcePending = false;
    }
    /**
     * Registers a new FAB action.
     *
     * **Note:** `announceButtons()` must be called after all actions are registered.
     *
     * @param id FAB id
     * @param title FAB title
     * @param icon FAB icon (mat-icon)
     * @param action FAB action factory (e.g. `() => this.myAction()`)
     * @param outOfContext Flag indicating if action moves user to a different context
     * @param order Button order in FAB
     * @param colorOptions Button optional color options
     */
    registerAction(id, title, icon, action, outOfContext = false, order = 0, colorOptions, secondaryAction = false) {
      this.buttons.push(new FloatingActionButtonItem(id, title, icon, action, outOfContext, order, colorOptions, secondaryAction));
    }
    /**
     * Unregisters a single FAB action.
     *
     * **Note:** `announceButtons()` must be called after unregistering action.
     *
     * @param id FAB action id
     */
    unRegisterAction(id) {
      const index = this.buttons.findIndex(o => o.id === id);
      if (index > -1) {
        this.buttons.splice(index, 1);
      }
    }
    /**
     * Announces registered buttons to FAB UI.
     */
    announceButtons() {
      // Throttle announces so only one announce can happen at a time
      if (!this.announcePending) {
        this.announcePending = true;
        // Sort & announce buttons async (move to end of event queue)
        setTimeout(() => {
          this.sortActionButtonItems();
          this.buttons$.next([...this.buttons]);
          this.announcePending = false;
        });
      }
    }
    /**
     * Gets currently stored floating action buttons.
     */
    getButtons() {
      return [...this.buttons];
    }
    /**
     * Sets FAB visibility.
     *
     * Sometimes it is useful to temporarily hide FAB, f.ex. when the user
     * opens bottom sheet or some other layered content that is below FAB.
     *
     * @param isVisible Boolean value that dictates if FAB is visible or not
     */
    setVisibility(isVisible) {
      this.isVisible$.next(isVisible);
    }
    /**
     * Sets FAB disabled state.
     *
     * When FAB is in disabled state it wont react to any user interactions.
     * Useful when wanting to prevent double click actions with smooth scrolling etc.
     *
     * @param isDisabled Boolean value that dictates if FAB is disabled or not
     */
    setDisabled(isDisabled) {
      this.isDisabled$.next(isDisabled);
    }
    /**
     * FAB should publish actions in actionEvents$ stream.
     *
     * @param event Action event
     */
    announceActionEvent(event) {
      const clickedItem = this.buttons.find(button => {
        return button.id === event;
      });
      // Perform action (if item exists)
      clickedItem?.action();
    }
    /**
     * Resets the FAB service and UI state.
     */
    resetState() {
      this.buttons = [];
      this.buttons$.next([]);
      this.reset$.next();
    }
    /**
     * Sorts action button items based on order number.
     */
    sortActionButtonItems() {
      this.buttons.sort((a, b) => a.order < b.order ? -1 : a.order > b.order ? 1 : 0);
    }
    static {
      this.ɵfac = function FloatingActionButtonService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FloatingActionButtonService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FloatingActionButtonService,
        factory: FloatingActionButtonService.ɵfac
      });
    }
  }
  return FloatingActionButtonService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FloatingActionButtonItemComponent = /*#__PURE__*/(() => {
  class FloatingActionButtonItemComponent {
    constructor() {
      // When we want to give the user an option to select something 
      // that isn't directly related to the current view's content
      this.outOfContext = false;
    }
    ngOnInit() {
      this.icon = this.icon || 'help';
    }
    static {
      this.ɵfac = function FloatingActionButtonItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FloatingActionButtonItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FloatingActionButtonItemComponent,
        selectors: [["hpo-floating-action-button-item"]],
        inputs: {
          id: "id",
          title: "title",
          icon: "icon",
          outOfContext: "outOfContext",
          colorOptions: "colorOptions"
        },
        decls: 8,
        vars: 11,
        consts: [[1, "fab-item-container"], [1, "fab-item", 3, "ngClass"], [1, "fab-icon"], [1, "fab-title-container"], [1, "fab-title"]],
        template: function FloatingActionButtonItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "mat-icon");
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 3)(6, "div", 4);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("id", ctx.id);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("color", ctx.colorOptions == null ? null : ctx.colorOptions.color)("background-color", ctx.colorOptions == null ? null : ctx.colorOptions.backgroundColor);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(8, _c30, ctx.outOfContext, !ctx.outOfContext));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.icon);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
          }
        },
        dependencies: [i1.NgClass, i3$2.MatIcon],
        styles: [".fab-item-container[_ngcontent-%COMP%]{position:relative;transition:top .15s,opacity .15s;width:100%}.fab-item-container[_ngcontent-%COMP%]   .fab-item[_ngcontent-%COMP%]{color:#fff;display:flex;align-items:center;justify-content:left;padding:.8rem 6rem .8rem .8rem;width:100%;transition:background-color .1s,opacity .1s}.fab-item-container[_ngcontent-%COMP%]   .fab-item.in-context[_ngcontent-%COMP%]{color:var(--color-text-dark-gray)}.fab-item-container[_ngcontent-%COMP%]   .fab-item.in-context[_ngcontent-%COMP%]:hover{background-color:#0000000d;cursor:pointer}.fab-item-container[_ngcontent-%COMP%]   .fab-item.in-context[_ngcontent-%COMP%]   .fab-icon[_ngcontent-%COMP%]{padding-left:1rem;padding-right:.8rem}.fab-item-container[_ngcontent-%COMP%]   .fab-item.in-context[_ngcontent-%COMP%]   .fab-title-container[_ngcontent-%COMP%]{padding:.5rem;text-align:left}.fab-item-container[_ngcontent-%COMP%]   .fab-item.in-context[_ngcontent-%COMP%]   .fab-title-container[_ngcontent-%COMP%]   .fab-title[_ngcontent-%COMP%]{display:inline-block;padding:.5rem;border-radius:3px;font-size:1.6rem;font-weight:500}.fab-item-container[_ngcontent-%COMP%]   .fab-item.out-of-context[_ngcontent-%COMP%]{background-color:var(--color-primary);color:var(--color-primary-contrast)}.fab-item-container[_ngcontent-%COMP%]   .fab-item.out-of-context[_ngcontent-%COMP%]:hover{opacity:.75;cursor:pointer}.fab-item-container[_ngcontent-%COMP%]   .fab-item.out-of-context[_ngcontent-%COMP%]   .fab-icon[_ngcontent-%COMP%]{padding-left:1rem;padding-right:.8rem}.fab-item-container[_ngcontent-%COMP%]   .fab-item.out-of-context[_ngcontent-%COMP%]   .fab-title-container[_ngcontent-%COMP%]{padding:.5rem;text-align:left}.fab-item-container[_ngcontent-%COMP%]   .fab-item.out-of-context[_ngcontent-%COMP%]   .fab-title-container[_ngcontent-%COMP%]   .fab-title[_ngcontent-%COMP%]{display:inline-block;padding:.5rem;border-radius:3px;font-size:1.6rem;font-weight:500}"],
        changeDetection: 0
      });
    }
  }
  return FloatingActionButtonItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FloatingActionButtonComponent = /*#__PURE__*/(() => {
  class FloatingActionButtonComponent {
    constructor(fabService, cdRef) {
      this.fabService = fabService;
      this.cdRef = cdRef;
      this.icon = 'add';
      this.mobile = false;
      // Is the FAB visible or disabled
      this.isVisible = true;
      this.isDisabled = false;
      // Are the buttons visible (ie. is FAB opened into a menu)
      this.buttonsAreVisible = false;
      this.buttons = [];
      this.secondaryFabButton = null;
      this.width = 56;
      this.height = 56;
      this.singleButtonWidth = 56;
      this.singleButtonHeight = 56;
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.fabService.buttons$.pipe(takeUntil(this.destroy$)).subscribe(buttons => {
        this.buttons = buttons.filter(btn => !btn.secondaryAction);
        // set secondary fab button
        const secondaryActions = buttons.filter(btn => btn.secondaryAction);
        this.secondaryFabButton = secondaryActions.length > 0 ? secondaryActions[0] : null;
        this.cdRef.markForCheck();
        // Move to the end of event queue so change detection will be run before this
        setTimeout(() => {
          this.setSingleButtonDimensions();
          this.cdRef.markForCheck();
        });
      });
      this.fabService.reset$.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.buttonsAreVisible = false;
        this.cdRef.markForCheck();
      });
      this.fabService.isVisible$.pipe(takeUntil(this.destroy$)).subscribe(isVisible => {
        this.isVisible = isVisible;
        this.cdRef.markForCheck();
        // if FAB was hidden when registering new actions (in mobile view with bottom sheet),
        // button width & height was set to 0 above and needs to be set right.
        if (this.isVisible) {
          // Move to the end of event queue so change detection will be run before this
          setTimeout(() => {
            this.setSingleButtonDimensions();
            this.cdRef.markForCheck();
          });
        }
      });
      this.fabService.isDisabled$.pipe(takeUntil(this.destroy$)).subscribe(isDisabled => {
        this.isDisabled = isDisabled;
        this.cdRef.markForCheck();
      });
    }
    /**
     * Clean up when component is removed
     */
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
      // Clear service state
      this.fabService.resetState();
    }
    /**
     * Toggle between displaying and hiding sub-buttons
     * @param state True = buttons are visible, false = buttons are hidden
     */
    fabOpenState(state) {
      if (state && !this.isDisabled && this.buttons.length > 0) {
        this.buttonsAreVisible = true;
      } else {
        this.buttonsAreVisible = false;
      }
      this.width = this.buttonsAreVisible ? this.singleButtonWidth : 56;
      this.height = this.buttonsAreVisible ? this.singleButtonHeight : 56;
    }
    /**
     * Publish action strings to the referenced event stream
     * @param event Action string
     */
    actionClicked(action) {
      if (!this.isDisabled) {
        this.fabService.announceActionEvent(action);
      }
      this.fabOpenState(false);
    }
    setSingleButtonDimensions() {
      if (this.buttons.length > 0 && this.buttonsElement) {
        this.singleButtonWidth = this.buttonsElement.nativeElement.offsetWidth;
        this.singleButtonHeight = this.buttonsElement.nativeElement.offsetHeight;
      }
    }
    static {
      this.ɵfac = function FloatingActionButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FloatingActionButtonComponent)(i0.ɵɵdirectiveInject(FloatingActionButtonService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FloatingActionButtonComponent,
        selectors: [["hpo-floating-action-button"]],
        viewQuery: function FloatingActionButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c31, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonsElement = _t.first);
          }
        },
        inputs: {
          icon: "icon",
          mobile: "mobile",
          id: "id"
        },
        decls: 5,
        vars: 11,
        consts: [["secondaryFabTemplate", ""], ["actionButtons", ""], ["class", "fab", 3, "ngClass", "ngStyle", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "click", "ngClass"], [1, "fab", 3, "ngClass", "ngStyle"], ["id", "fab"], [4, "ngIf"], [1, "buttons"], [1, "grid", 3, "ngClass"], ["class", "transitioning-button", 3, "title", "id", "icon", "outOfContext", "colorOptions", "click", 4, "ngFor", "ngForOf"], [1, "icon", 3, "click", "ngClass"], [1, "transitioning-button", 3, "click", "title", "id", "icon", "outOfContext", "colorOptions"], ["class", "fab secondary", 3, "ngClass", "ngStyle", 4, "ngIf"], [1, "fab", "secondary", 3, "ngClass", "ngStyle"]],
        template: function FloatingActionButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, FloatingActionButtonComponent_div_0_Template, 7, 19, "div", 2);
            i0.ɵɵelementContainer(1, 3);
            i0.ɵɵelementStart(2, "div", 4);
            i0.ɵɵlistener("click", function FloatingActionButtonComponent_Template_div_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.fabOpenState(false));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, FloatingActionButtonComponent_ng_template_3_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const secondaryFabTemplate_r10 = i0.ɵɵreference(4);
            i0.ɵɵproperty("ngIf", (ctx.buttons == null ? null : ctx.buttons.length) > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", secondaryFabTemplate_r10)("ngTemplateOutletContext", i0.ɵɵpureFunction2(4, _c32, ctx.secondaryFabButton, !ctx.buttonsAreVisible));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c33, ctx.buttonsAreVisible, ctx.buttonsAreVisible && ctx.mobile, !ctx.buttonsAreVisible));
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i1.NgStyle, i3$2.MatIcon, FloatingActionButtonItemComponent],
        styles: ["@media print{[_nghost-%COMP%]{display:none!important}}.fab[_ngcontent-%COMP%]{position:fixed;z-index:901;overflow:hidden;cursor:pointer;box-shadow:0 4px 5px -1px #0006;background-color:var(--color-accent);border-radius:28px;width:5.6rem;height:5.6rem;transition:width .25s,height .25s;transition-timing-function:cubic-bezier(.4,0,.2,1)}.fab.visible[_ngcontent-%COMP%]{display:initial}.fab.hidden[_ngcontent-%COMP%]{display:none}.fab[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{color:var(--color-accent-contrast);width:56px;height:56px;text-align:center;padding-top:1.6rem}.fab[_ngcontent-%COMP%]   .icon.visible[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_make-icon-visible .5s}.fab.closed[_ngcontent-%COMP%]{pointer-events:all}.fab.open[_ngcontent-%COMP%]{pointer-events:none;animation:_ngcontent-%COMP%_open-items .25s;border-radius:3px;width:auto;height:auto;background-color:#fff}.fab.mobile[_ngcontent-%COMP%]{right:2.8rem;bottom:8rem}.fab.desktop[_ngcontent-%COMP%]{right:2.8rem;top:2rem}.fab[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]{width:max-content}.fab[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   .visible[_ngcontent-%COMP%]{animation:_ngcontent-%COMP%_make-items-visible .25s;opacity:1;pointer-events:all}.fab[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   .hidden[_ngcontent-%COMP%]{opacity:0;pointer-events:none}.fab[_ngcontent-%COMP%]   .buttons[_ngcontent-%COMP%]   .grid[_ngcontent-%COMP%]{border-radius:3px;box-shadow:0 1px 6px #0006;display:grid;grid-template-rows:1fr;padding:0;overflow:hidden}.fab.secondary[_ngcontent-%COMP%]{background-color:#d3d4d6}.fab.secondary[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{color:#4a4a4a}.fab.secondary.mobile[_ngcontent-%COMP%]{right:2.8rem;bottom:15.2rem}.fab.secondary.desktop[_ngcontent-%COMP%]{right:2.8rem;top:9.2rem}@keyframes _ngcontent-%COMP%_make-icon-visible{0%{opacity:0}60%{opacity:0}to{opacity:1}}@keyframes _ngcontent-%COMP%_make-items-visible{0%{opacity:0}50%{opacity:0}to{opacity:1}}@keyframes _ngcontent-%COMP%_open-items{0%{border-radius:28px;background-color:var(--color-accent)}40%{background-color:var(--color-accent)}to{border-radius:3px;background-color:#fff}}.fab-screen-layer[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;bottom:0;z-index:900;pointer-events:all;transition:background-color .25s}.fab-screen-layer-mobile[_ngcontent-%COMP%]{background-color:#00000040}.fab-screen-layer-hidden[_ngcontent-%COMP%]{width:0px;height:0px;background:#0000;pointer-events:none}"],
        changeDetection: 0
      });
    }
  }
  return FloatingActionButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FloatingActionButtonModule = /*#__PURE__*/(() => {
  class FloatingActionButtonModule {
    static {
      this.ɵfac = function FloatingActionButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FloatingActionButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FloatingActionButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatIconModule]
      });
    }
  }
  return FloatingActionButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HpoButtonItemComponent = /*#__PURE__*/(() => {
  class HpoButtonItemComponent {
    constructor() {
      this.primary = null;
      this.color = '';
      this.disabled = false;
      this.click = new EventEmitter();
      this.changes$ = new Subject();
      this.isInitialChange = true;
    }
    ngOnChanges(changes) {
      if (!this.isInitialChange) {
        this.changes$.next();
      } else {
        this.isInitialChange = false;
      }
    }
    get isPrimary() {
      // If property is string (even empty one) button is primary, otherwise it's secondary
      return typeof this.primary === 'string';
    }
    static {
      this.ɵfac = function HpoButtonItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoButtonItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HpoButtonItemComponent,
        selectors: [["hpo-button-item"]],
        viewQuery: function HpoButtonItemComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(TemplateRef, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
          }
        },
        inputs: {
          id: "id",
          primary: "primary",
          color: "color",
          disabled: "disabled"
        },
        outputs: {
          click: "click"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c8,
        decls: 1,
        vars: 0,
        template: function HpoButtonItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, HpoButtonItemComponent_ng_template_0_Template, 1, 0, "ng-template");
          }
        },
        changeDetection: 0
      });
    }
  }
  return HpoButtonItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: Button styles wont work with m2 fallback styles.
//       Fix them when moved to m3.
const BUTTON_STYLES = ['',
// Represents default button (mat-button)
'raised', 'stroked', 'flat'];
let HpoSplitButtonComponent = /*#__PURE__*/(() => {
  class HpoSplitButtonComponent {
    constructor(cdRef, renderer) {
      this.cdRef = cdRef;
      this.renderer = renderer;
      this.buttonStyle = BUTTON_STYLES[0];
      this.color = '';
      this.disabled = false;
      this.isFluidMenu = true;
      this.maxMenuWidth = 400; // Effective only when isFluidMenu is true
      this.secondaryButtonItems = [];
      this.isInitialized = false;
      this.destroy$ = new Subject();
      // This contains subscriptions for button item change detectors.
      // No need to loop through this in ngOnDestroy as those subscriptions also have destroy pipe.
      this.buttonItemCdSubscriptions = [];
    }
    ngOnChanges(changes) {
      if (changes['buttonStyle']) {
        const proposedStyle = changes['buttonStyle'].currentValue;
        if (!BUTTON_STYLES.includes(proposedStyle)) {
          this.buttonStyle = BUTTON_STYLES[0];
        }
        // If component is initialized call the set method otherwise do nothing
        // as after the component initialization in ngAfterViewInit the same method will be called.
        if (this.isInitialized) {
          this.setPrimaryButtonStyle();
        }
      }
    }
    ngAfterContentInit() {
      // React to changes in button item list (adds, removes; not the individual components)
      this.buttonItems.changes.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.setButtonItems();
        this.cdRef.markForCheck();
      });
      this.setButtonItems();
    }
    ngAfterViewInit() {
      // When items menu opens set it's width to match the split button's width
      this.itemsMenuTrigger.menuOpened.pipe(takeUntil(this.destroy$)).subscribe(() => {
        // Move operation to the end of event queue so rendering happens before it
        setTimeout(() => {
          const menuPanelElem = document.querySelector('.hpo-sb-items-menu');
          this.renderer.addClass(menuPanelElem, this.isFluidMenu ? 'fluid-menu' : 'fixed-menu');
          const menuPanelWidth = menuPanelElem.offsetWidth;
          const primaryButtonWidth = this.primaryButtonElemRef.nativeElement.offsetWidth;
          const primaryDropdownButtonWidth = this.primaryDropdownButtonElemRef.nativeElement.offsetWidth;
          const combinedButtonsWidth = primaryButtonWidth + primaryDropdownButtonWidth;
          // If menu is fluid and menu width is over soft max width and button width is not, set menu width as soft max
          if (this.isFluidMenu && menuPanelWidth > this.maxMenuWidth && combinedButtonsWidth <= this.maxMenuWidth) {
            this.renderer.setStyle(menuPanelElem, 'width', this.maxMenuWidth + 'px');
            // If menu is not fluid or button is wider than menu, set menu as wide as button.
            //
            // Or if menu is fluid and menu width is over soft max width and button width is also over it,
            // set menu as wide as button unless width exceeds menu hard max width (hardcoded in styles).
          } else if (!this.isFluidMenu || menuPanelWidth < combinedButtonsWidth || combinedButtonsWidth > this.maxMenuWidth) {
            this.renderer.setStyle(menuPanelElem, 'width', combinedButtonsWidth + 'px');
          }
          // Otherwise menu width is fine and there's no need to change it
          // FYI: No mark for check is needed as this modifies the native element directly
        });
      });
      // Set primary button style after component view initialization
      this.setPrimaryButtonStyle();
      // Finally mark the component as initialized
      this.isInitialized = true;
      // Workaround for a bug (see setButtonItems method)
      setTimeout(() => this.cdRef.markForCheck());
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    openItemsMenu() {
      this.itemsMenuTrigger.openMenu();
    }
    primaryButtonClick(event) {
      this.primaryButtonItem?.click.emit(event);
    }
    secondaryButtonClick(buttonItemIndex, event) {
      this.secondaryButtonItems[buttonItemIndex]?.click.emit(event);
    }
    setButtonItems() {
      const primaryButtonItems = this.buttonItems.filter(o => o.isPrimary);
      const secondaryButtonItems = this.buttonItems.filter(o => !o.isPrimary);
      if (primaryButtonItems.length !== 1) {
        console.error(`[HPO Split button${this.id ? ` (#${this.id})` : ''}] Element must have exactly one primary button active. Now it has`, primaryButtonItems.length);
      }
      // FYI: There is a bug with OnPush components (on version 10.2.4) similar to this https://github.com/angular/angular/issues/16012
      //      where ngTemplateOutlet wont project anything after initial change detection.
      //      It projects only after second change detection, be it user event or manually triggered.
      //      After that it works normally and updates alongside other template properties.
      this.primaryButtonItem = primaryButtonItems[0]; // Might return undefined if user didn't give primary button item
      this.secondaryButtonItems = secondaryButtonItems;
      // Unsubscribe from previous button item change detector subscriptions
      this.buttonItemCdSubscriptions.forEach(o => o.unsubscribe());
      this.buttonItemCdSubscriptions = [];
      // Set change detectors for button items so this component
      // will be notified when something is changed in those.
      this.setButtonItemChangeDetector(this.primaryButtonItem); // Yes this can be undefined but the method handles it ;)
      this.secondaryButtonItems.forEach(o => this.setButtonItemChangeDetector(o));
    }
    setButtonItemChangeDetector(buttonItem) {
      if (buttonItem) {
        this.buttonItemCdSubscriptions.push(buttonItem.changes$.pipe(takeUntil(this.destroy$)).subscribe(() => this.cdRef.markForCheck()));
      }
    }
    setPrimaryButtonStyle() {
      this.setButtonStyle(this.primaryButtonElemRef);
      this.setButtonStyle(this.primaryDropdownButtonElemRef);
    }
    setButtonStyle(buttonElemRef) {
      if (!buttonElemRef) {
        return;
      }
      // Add changed style class to button
      this.renderer.addClass(buttonElemRef.nativeElement, this.getMatButtonClass(this.buttonStyle));
      // Remove all other style classes from button
      BUTTON_STYLES.filter(s => s !== this.buttonStyle).forEach(s => this.renderer.removeClass(buttonElemRef.nativeElement, this.getMatButtonClass(s)));
      // FYI: No mark for check is needed as this modifies the native element directly
    }
    getMatButtonClass(buttonStyle) {
      return buttonStyle ? `mat-${buttonStyle}-button` : 'mat-button';
    }
    static {
      this.ɵfac = function HpoSplitButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoSplitButtonComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HpoSplitButtonComponent,
        selectors: [["hpo-split-button"]],
        contentQueries: function HpoSplitButtonComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, HpoButtonItemComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonItems = _t);
          }
        },
        viewQuery: function HpoSplitButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
            i0.ɵɵviewQuery(_c39, 5, ElementRef);
            i0.ɵɵviewQuery(_c40, 5, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsMenuTrigger = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.primaryButtonElemRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.primaryDropdownButtonElemRef = _t.first);
          }
        },
        inputs: {
          id: "id",
          buttonStyle: "buttonStyle",
          color: "color",
          disabled: "disabled",
          isFluidMenu: "isFluidMenu",
          maxMenuWidth: "maxMenuWidth"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 12,
        vars: 12,
        consts: [["primaryButton", ""], ["primaryDropdownButton", ""], ["itemsMenu", "matMenu"], ["xPosition", "after", "yPosition", "below", 1, "items-menu-trigger", 3, "matMenuTriggerFor"], ["mat-stroked-button", "", 1, "primary-button", 3, "click", "color", "disabled"], [4, "ngTemplateOutlet"], ["mat-stroked-button", "", 1, "primary-dropdown-button", 3, "click", "color", "disabled"], [1, "dropdown-icon"], [1, "hpo-sb-items-menu"], ["mat-menu-item", "", 3, "ngClass", "disabled"], ["mat-menu-item", "", 3, "click", "ngClass", "disabled"]],
        template: function HpoSplitButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelement(0, "div", 3);
            i0.ɵɵelementStart(1, "button", 4, 0);
            i0.ɵɵlistener("click", function HpoSplitButtonComponent_Template_button_click_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.primaryButtonClick($event));
            });
            i0.ɵɵtemplate(3, HpoSplitButtonComponent_ng_container_3_Template, 1, 0, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "button", 6, 1);
            i0.ɵɵlistener("click", function HpoSplitButtonComponent_Template_button_click_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.openItemsMenu());
            });
            i0.ɵɵelementStart(6, "mat-icon", 7);
            i0.ɵɵtext(7, "arrow_drop_down");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "mat-menu", 8, 2);
            i0.ɵɵrepeaterCreate(10, HpoSplitButtonComponent_For_11_Template, 2, 4, "button", 9, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const itemsMenu_r6 = i0.ɵɵreference(9);
            i0.ɵɵproperty("matMenuTriggerFor", itemsMenu_r6);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("with-dropdown", ctx.secondaryButtonItems.length > 0);
            i0.ɵɵproperty("color", (ctx.primaryButtonItem == null ? null : ctx.primaryButtonItem.color) || ctx.color)("disabled", ctx.disabled || (ctx.primaryButtonItem == null ? null : ctx.primaryButtonItem.disabled));
            i0.ɵɵattribute("id", ctx.primaryButtonItem == null ? null : ctx.primaryButtonItem.id);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.primaryButtonItem == null ? null : ctx.primaryButtonItem.templateRef);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("hidden", ctx.secondaryButtonItems.length === 0);
            i0.ɵɵproperty("color", ctx.color)("disabled", ctx.disabled);
            i0.ɵɵattribute("id", ctx.id && ctx.id + "-dropdown-button");
            i0.ɵɵadvance(6);
            i0.ɵɵrepeater(ctx.secondaryButtonItems);
          }
        },
        dependencies: [i1.NgClass, i1.NgTemplateOutlet, i2.MatButton, i3$2.MatIcon, i4$1.MatMenu, i4$1.MatMenuItem, i4$1.MatMenuTrigger],
        styles: [".hpo-sb-items-menu.mat-mdc-menu-panel{max-width:64px}  .hpo-sb-items-menu.mat-mdc-menu-panel.fixed-menu{max-width:none}  .hpo-sb-items-menu.mat-mdc-menu-panel.fluid-menu{max-width:75vw}  .mat-mdc-dialog-actions hpo-split-button .mat-mdc-button-base+.mat-mdc-button-base{margin-left:0}[_nghost-%COMP%]{display:inline-block;white-space:nowrap}.hidden[_ngcontent-%COMP%]{display:none}button[_ngcontent-%COMP%]{text-transform:uppercase}.items-menu-trigger[_ngcontent-%COMP%]{display:inline-block;width:0;height:36px;vertical-align:middle;visibility:hidden;pointer-events:none}.primary-button.with-dropdown[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}.primary-button[_ngcontent-%COMP%]     .mdc-button__label{display:inline-flex;align-items:center;justify-content:center;gap:.8rem}.primary-dropdown-button[_ngcontent-%COMP%]{min-width:0;padding:0 .8rem;border-left:none;border-top-left-radius:0;border-bottom-left-radius:0}.primary-dropdown-button[_ngcontent-%COMP%]   .dropdown-icon[_ngcontent-%COMP%]{font-size:24px;width:24px;height:24px;margin:0}"],
        changeDetection: 0
      });
    }
  }
  return HpoSplitButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HpoSplitButtonModule = /*#__PURE__*/(() => {
  class HpoSplitButtonModule {
    static {
      this.ɵfac = function HpoSplitButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HpoSplitButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: HpoSplitButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule]
      });
    }
  }
  return HpoSplitButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiSearchFilterComponent = /*#__PURE__*/(() => {
  class MultiSearchFilterComponent {
    set value(val) {
      this._val = val;
      this.update();
    }
    set options(opts) {
      if (!opts) return;
      this._listOptions = opts.map(item => ({
        name: item.name,
        searchValues: item.searchValues
      }));
    }
    get value() {
      return this._val;
    }
    get options() {
      return this._listOptions;
    }
    constructor(
    // Retrieve the dependency only from the local injector, not from parent or ancestors.
    ngControl) {
      this.ngControl = ngControl;
      this.onChange = value => {};
      this.onTouch = () => {};
      this.title = '';
      this.subTitle = '';
      this.autoFocus = false;
      this.multiple = false; // allow select multiple values
      this.showTooltip = false;
      this.errorMessage = '';
      this.inputChanged = new EventEmitter();
      this._listOptions = []; // dropdown list;
      this._val = null;
      this.search = new ReplaySubject(1);
      this.search$ = this.search.asObservable();
      this.unsubscribe$ = new Subject();
      // public chipValues: Array<string> = [];
      this.selectedOption = null;
      this.selectedStartDate = null;
      this.selectedEndDate = null;
      this.selectedValueMin = 0;
      this.selectedValueMax = 0;
      this.isRequired = false;
      // Setting the value accessor directly (instead of using the providers) to avoid running into a circular import.
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
    }
    ngOnInit() {
      // listen input value changes
      this.search$.pipe(debounceTime(400), takeUntil(this.unsubscribe$)).subscribe(obj => {
        if (!this.disabled) {
          this.value = obj.value;
          this.onChanged(obj.value);
          this.onTouched();
          this.inputChanged.emit(obj);
        }
      });
    }
    /**
     * Emit text input value
     * @param value
     */
    onTextChange(value) {
      this.search.next({
        key: this.id,
        value
      });
    }
    /** Emit number value*/
    onNumberChange() {
      const numberRange = {
        min: this.selectedValueMin,
        max: this.selectedValueMax
      };
      this.value = numberRange;
      this.onChanged(numberRange);
      this.onTouched();
      this.inputChanged.emit({
        key: this.id,
        value: numberRange
      });
    }
    onExactNumberChange(event) {
      if (event) {
        event = parseInt(event);
      } else {
        event = null;
      }
      this.value = event;
      this.onChanged(event);
      this.onTouched();
      this.inputChanged.emit({
        key: this.id,
        value: event
      });
    }
    /** Emit date value */
    onDateChange() {
      if (this.disabled) return;
      const dateRange = {
        start: this.selectedStartDate,
        end: this.selectedEndDate
      };
      this.value = dateRange;
      this.onChanged(dateRange);
      this.onTouched();
      this.inputChanged.emit({
        key: this.id,
        value: dateRange
      });
    }
    /** Emit checkbox value */
    onToggleChange(event) {
      if (this.disabled) return;
      this.value = event;
      this.onChanged(event);
      this.onTouched();
      this.inputChanged.emit({
        key: this.id,
        value: event
      });
    }
    /** Emit dropdown value */
    onSelectChange(event) {
      if (this.disabled) return;
      this.value = event;
      this.onChanged(event);
      this.onTouched();
      this.inputChanged.emit({
        key: this.id,
        value: event
      });
    }
    /** Get selected dropdown value */
    getSelectedOption(value) {
      const option = this.options.find(opt => opt.name === value);
      if (option) {
        return option;
      }
      return null;
    }
    addChipValue(event) {
      const tmpValue = (event.value || '').trim();
      if (tmpValue) {
        this.value.push(tmpValue);
      }
      this.inputChanged.emit({
        key: this.id,
        value: this.value
      });
      // Clear the input value
      event.input.value = '';
    }
    removeChipValue(tmpValue) {
      const index = this.value.indexOf(tmpValue);
      if (index >= 0) {
        this.value.splice(index, 1);
      }
      this.inputChanged.emit({
        key: this.id,
        value: this.value
      });
    }
    ngOnChanges() {
      this.update();
    }
    /**
     * update selected values
     */
    update() {
      if (this.type === 'number') {
        this.selectedValueMin = this.value ? this.value.min : null;
        this.selectedValueMax = this.value ? this.value.max : null;
      }
      if (this.type === 'date') {
        this.selectedStartDate = this.value ? this.value.start : null;
        this.selectedEndDate = this.value ? this.value.end : null;
      }
      if (this.type === 'dropdown') {
        if (this.multiple) {
          this.selectedOption = this.value;
        } else {
          const newValue = this.value ? this.value.name : null;
          this.selectedOption = this.getSelectedOption(newValue);
        }
      }
      // check form validation if value changes
      this.updateNgControl();
    }
    /**
     * Update ng control validation
     */
    updateNgControl() {
      if (this.ngControl) {
        let abstractControl = this.ngControl.control;
        if (abstractControl) {
          this.isRequired = abstractControl.enabled && !!abstractControl.validator;
        }
      }
    }
    ngAfterViewInit() {
      if (this.autoFocus) {
        this.onFocus();
      }
    }
    ngOnDestroy() {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
    /* Methods needed by ControlValueAccessor to transform this component into a "form friendly" component */
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    onChanged(value) {
      if (this.onChange) {
        this.onChange(value);
      }
    }
    onTouched() {
      if (this.onTouch) {
        this.onTouch();
      }
    }
    onFocus() {
      if (this.input) {
        this.input.nativeElement.focus();
      }
    }
    static {
      this.ɵfac = function MultiSearchFilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MultiSearchFilterComponent)(i0.ɵɵdirectiveInject(i4.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiSearchFilterComponent,
        selectors: [["hpo-multi-search-filter"]],
        viewQuery: function MultiSearchFilterComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c41, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.input = _t.first);
          }
        },
        inputs: {
          id: "id",
          type: "type",
          title: "title",
          subTitle: "subTitle",
          disabled: "disabled",
          autoFocus: "autoFocus",
          multiple: "multiple",
          showTooltip: "showTooltip",
          errorStateMatcher: "errorStateMatcher",
          errorMessage: "errorMessage",
          value: "value",
          options: "options"
        },
        outputs: {
          inputChanged: "inputChanged"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 8,
        vars: 7,
        consts: [["input", ""], ["chipList", ""], [1, "card"], [4, "ngIf"], [3, "change", "id", "checked", "disabled"], ["matInput", "", "maxlength", "50", "type", "text", 3, "input", "focus", "id", "value", "disabled"], [3, "selectedChange", "id", "title", "data", "multiple", "showTooltip", "selected", "allowEmpty", "searchBy", "disabled", "isRequired", "errorStateMatcher", "errorMessage"], [1, "input-group"], [3, "valueChange", "id", "value", "hideTimeInput", "datePlaceholder", "disabled"], [3, "valueChange", "id", "value", "hideTimeInput", "endOfDayTime", "datePlaceholder", "disabled"], ["matInput", "", "maxlength", "50", "type", "number", 3, "change", "focus", "valueChange", "id", "value", "disabled"], [3, "numberChange", "id", "placeholder", "number", "emitNullAsZero", "readonly"], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], [3, "matChipInputTokenEnd", "placeholder", "matChipInputFor", "matChipInputAddOnBlur"], [3, "removed", "selectable", "removable"], ["matChipRemove", ""]],
        template: function MultiSearchFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, MultiSearchFilterComponent_ng_container_1_Template, 4, 6, "ng-container", 3)(2, MultiSearchFilterComponent_ng_container_2_Template, 7, 6, "ng-container", 3)(3, MultiSearchFilterComponent_ng_container_3_Template, 4, 14, "ng-container", 3)(4, MultiSearchFilterComponent_ng_container_4_Template, 6, 15, "ng-container", 3)(5, MultiSearchFilterComponent_ng_container_5_Template, 8, 6, "ng-container", 3)(6, MultiSearchFilterComponent_ng_container_6_Template, 6, 14, "ng-container", 3)(7, MultiSearchFilterComponent_ng_container_7_Template, 9, 7, "ng-container", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "checkbox");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "text");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "dropdown");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "date");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "exactNumber");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "number");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "chips");
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i3$3.MatCheckbox, i4$2.MatChipGrid, i4$2.MatChipInput, i4$2.MatChipRemove, i4$2.MatChipRow, i2$2.MatInput, i3$1.MatFormField, i3$1.MatLabel, i3$2.MatIcon, SelectContainerComponent, DatetimepickerComponent, HpoNumberComponent, i1.LowerCasePipe, i1$1.BlahPipe],
        styles: ["*[_ngcontent-%COMP%]{box-sizing:border-box}.mat-mdc-checkbox[_ngcontent-%COMP%]{margin-left:0;margin-right:12px}  .mat-mdc-autocomplete-panel .mat-mdc-selection-list mat-list-option .mdc-list-item__start{margin-right:12px!important}.mat-mdc-form-field[_ngcontent-%COMP%]   .mat-form-field-prefix[_ngcontent-%COMP%], .mat-form-field[_ngcontent-%COMP%]   .mat-form-field-suffix[_ngcontent-%COMP%]{align-self:flex-end}hpo-number[_ngcontent-%COMP%]{flex:1 1 0px;margin-right:5px}[_nghost-%COMP%]     hpo-datetimepicker{flex:1 1 0px}[_nghost-%COMP%]     hpo-datetimepicker .datefield{width:100%}[_nghost-%COMP%]     hpo-datetimepicker .input{font-size:1.4rem}[_nghost-%COMP%]     hpo-select{width:100%}[_nghost-%COMP%]     hpo-number .input{font-size:14px}[_nghost-%COMP%]     hpo-number .right{text-align:left}.input-group[_ngcontent-%COMP%]{display:flex}"]
      });
    }
  }
  return MultiSearchFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiSearchFilterModule = /*#__PURE__*/(() => {
  class MultiSearchFilterModule {
    static {
      this.ɵfac = function MultiSearchFilterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MultiSearchFilterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MultiSearchFilterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, MatCheckboxModule, MatChipsModule, MatInputModule, MatButtonModule, MatIconModule, SelectModule, DatetimepickerModule, InputModule, HpoNumberModule, BlahModule]
      });
    }
  }
  return MultiSearchFilterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* Day.js */

/**
 * Generated bundle index. Do not edit.
 */

export { AddSearchComponent, AddSearchModule, BottomNavComponent, BottomNavModule, BottomSheetComponent, BottomSheetModule, ButtonComponent, ButtonModule, CardActionsComponent, CardComponent, CardContentComponent, CardHeaderComponent, CardModule, ContentBlockComponent, ContentLayoutComponent, ContentLayoutModule, ContentLayoutService, DatetimepickerComponent, DatetimepickerModule, DayjsDateAdapter, DayjsDateModule, DayjsPipe, DayjsPipeModule, FloatingActionButtonComponent, FloatingActionButtonItem, FloatingActionButtonItemComponent, FloatingActionButtonModule, FloatingActionButtonService, FullScreenDialogComponent, FullScreenDialogModule, FullScreenDialogService, HpoButtonItemComponent, HpoIconComponent, HpoIconModule, HpoNumberComponent, HpoNumberModule, HpoSplitButtonComponent, HpoSplitButtonModule, InputComponent, InputModule, ListComponent, ListItemComponent, ListModule, MAT_DAYJS_DATE_ADAPTER_OPTIONS, MAT_DAYJS_DATE_ADAPTER_OPTIONS_FACTORY, MAT_DAYJS_DATE_FORMATS, MapComponent, MapModule, MatDayjsDateModule, MultiSearchFilterComponent, MultiSearchFilterModule, NavItemComponent, NoteComponent, NoteModule, NotificationComponent, NotificationModule, PlaceholderComponent, PlaceholderModule, SelectContainerComponent, SelectModule, SheetActionsComponent, SheetContentComponent, SheetDividerComponent, SheetItemComponent, SpinnerComponent, SpinnerModule, TextComponent, TextModule, TextTruncatePipe, TextTruncatePipeModule, TextareaComponent, TextareaModule, TimeAgoPipe, TimeAgoPipeModule, provideDayjsDateAdapter };
